// src/auth.ts
var MOCK_USERS = [
  {
    email: "user@example.com",
    password: "$2b$10$JPIwLTDMXGZL/bKXB/oRn.eciauwclorSq1xSnnmxOD5Yia8euT6O"
    // User@123
  },
  {
    email: "admin@example.com",
    password: "$2b$10$OtpOvJ5q/1ptxIJad.nhQOsoak2PMJlAifI6QMQnvHaEsoFd9Azuq"
    //123@adminPassword
  }
];

// src/image.ts
var imageMock = {
  src: "/images/logo-light-mode.png",
  alt: "Logo of the application",
  width: 180,
  height: 56
};

// src/mapbox.ts
var MOCK_ADDRESS_SUGGESTIONS = [
  {
    id: "1",
    text: "New York",
    place_name: "New York City, NY, USA",
    center: [-74.006, 40.7128],
    feature_type: "place"
  },
  {
    id: "2",
    text: "Los Angeles",
    place_name: "Los Angeles, CA, USA",
    center: [-118.2437, 34.0522],
    feature_type: "place"
  },
  {
    id: "3",
    text: "Chicago",
    place_name: "Chicago, IL, USA",
    center: [-87.6298, 41.8781],
    feature_type: "place"
  },
  {
    id: "4",
    text: "123 Main St",
    place_name: "123 Main St, Anytown, USA",
    center: [-73.9857, 40.7484],
    feature_type: "address"
  },
  {
    id: "5",
    text: "Central Park",
    place_name: "Central Park, New York, NY, USA",
    center: [-73.9654, 40.7829],
    feature_type: "poi"
  },
  {
    id: "6",
    text: "Paris",
    place_name: "Paris, France",
    center: [2.3522, 48.8566],
    feature_type: "place"
  },
  {
    id: "7",
    text: "Tokyo",
    place_name: "Tokyo, Japan",
    center: [139.6917, 35.6895],
    feature_type: "place"
  },
  {
    id: "8",
    text: "Sydney",
    place_name: "Sydney, NSW, Australia",
    center: [151.2093, -33.8688],
    feature_type: "place"
  },
  {
    id: "9",
    text: "H\xE0 N\u1ED9i",
    place_name: "H\xE0 N\u1ED9i, Vietnam",
    center: [105.8342, 21.0278],
    feature_type: "place"
  },
  {
    id: "10",
    text: "H\u1ED3 Ch\xED Minh City",
    place_name: "H\u1ED3 Ch\xED Minh City, Vietnam",
    center: [106.6297, 10.8231],
    feature_type: "place"
  },
  {
    id: "11",
    text: "456 Nguyen Hue",
    place_name: "456 Nguyen Hue Blvd, District 1, Ho Chi Minh City, Vietnam",
    center: [106.7033, 10.7756],
    feature_type: "address"
  },
  {
    id: "12",
    text: "Eiffel Tower",
    place_name: "Eiffel Tower, Paris, France",
    center: [2.2945, 48.8584],
    feature_type: "poi"
  },
  {
    id: "13",
    text: "London",
    place_name: "London, United Kingdom",
    center: [-0.1278, 51.5074],
    feature_type: "place"
  },
  {
    id: "14",
    text: "One Hacker Way",
    place_name: "One Hacker Way, Menlo Park, CA, USA",
    center: [-122.1484, 37.4843],
    feature_type: "address"
  },
  {
    id: "15",
    text: "Ho\xE0n Ki\u1EBFm Lake",
    place_name: "Ho\xE0n Ki\u1EBFm Lake, Hanoi, Vietnam",
    center: [105.8523, 21.0285],
    feature_type: "poi"
  }
];
var MOCK_MAPBOX_FEATURES = [
  {
    id: "feature_1",
    type: "Feature",
    place_type: ["place"],
    text: "New York",
    place_name: "New York City, NY, USA",
    properties: {
      name: "New York City",
      full_address: "New York City, NY, USA",
      place_formatted: "New York City",
      address: "New York, NY",
      mapbox_id: "dXJuOm1ieGFkZHI6ZmVhdHVyZS0x",
      feature_type: "place"
    },
    geometry: {
      type: "Point",
      coordinates: [-74.006, 40.7128]
    }
  },
  {
    id: "feature_2",
    type: "Feature",
    place_type: ["address"],
    text: "123 Main St",
    place_name: "123 Main St, Anytown, USA",
    properties: {
      name: "123 Main St",
      full_address: "123 Main St, Anytown, USA",
      place_formatted: "123 Main St",
      address: "Anytown, USA",
      mapbox_id: "dXJuOm1ieGFkZHI6ZmVhdHVyZS0y",
      feature_type: "address"
    },
    geometry: {
      type: "Point",
      coordinates: [-73.9857, 40.7484]
    }
  },
  {
    id: "feature_3",
    type: "Feature",
    place_type: ["poi"],
    text: "Central Park",
    place_name: "Central Park, New York, NY, USA",
    properties: {
      name: "Central Park",
      full_address: "Central Park, New York, NY, USA",
      place_formatted: "Central Park",
      address: "New York, NY, USA",
      mapbox_id: "dXJuOm1ieGFkZHI6ZmVhdHVyZS0z",
      feature_type: "poi"
    },
    geometry: {
      type: "Point",
      coordinates: [-73.9654, 40.7829]
    }
  },
  {
    id: "feature_4",
    type: "Feature",
    place_type: ["place"],
    text: "H\xE0 N\u1ED9i",
    place_name: "H\xE0 N\u1ED9i, Vietnam",
    properties: {
      name: "H\xE0 N\u1ED9i",
      full_address: "H\xE0 N\u1ED9i, Vietnam",
      place_formatted: "H\xE0 N\u1ED9i",
      address: "Vietnam",
      mapbox_id: "dXJuOm1ieGFkZHI6ZmVhdHVyZS00",
      feature_type: "place"
    },
    geometry: {
      type: "Point",
      coordinates: [105.8342, 21.0278]
    }
  },
  {
    id: "feature_5",
    type: "Feature",
    place_type: ["address"],
    text: "456 Nguyen Hue",
    place_name: "456 Nguyen Hue Blvd, District 1, Ho Chi Minh City, Vietnam",
    properties: {
      name: "456 Nguyen Hue",
      full_address: "456 Nguyen Hue Blvd, District 1, Ho Chi Minh City, Vietnam",
      place_formatted: "456 Nguyen Hue Blvd",
      address: "District 1, Ho Chi Minh City, Vietnam",
      mapbox_id: "dXJuOm1ieGFkZHI6ZmVhdHVyZS01",
      feature_type: "address"
    },
    geometry: {
      type: "Point",
      coordinates: [106.7033, 10.7756]
    }
  },
  {
    id: "feature_6",
    type: "Feature",
    place_type: ["poi"],
    text: "Ho\xE0n Ki\u1EBFm Lake",
    place_name: "Ho\xE0n Ki\u1EBFm Lake, Hanoi, Vietnam",
    properties: {
      name: "Ho\xE0n Ki\u1EBFm Lake",
      full_address: "Ho\xE0n Ki\u1EBFm Lake, Hanoi, Vietnam",
      place_formatted: "Ho\xE0n Ki\u1EBFm Lake",
      address: "Hanoi, Vietnam",
      mapbox_id: "dXJuOm1ieGFkZHI6ZmVhdHVyZS02",
      feature_type: "poi"
    },
    geometry: {
      type: "Point",
      coordinates: [105.8523, 21.0285]
    }
  },
  {
    id: "feature_7",
    type: "Feature",
    place_type: ["locality"],
    text: "District 1",
    place_name: "District 1, Ho Chi Minh City, Vietnam",
    properties: {
      name: "District 1",
      full_address: "District 1, Ho Chi Minh City, Vietnam",
      place_formatted: "District 1",
      address: "Ho Chi Minh City, Vietnam",
      mapbox_id: "dXJuOm1ieGFkZHI6ZmVhdHVyZS03",
      feature_type: "locality"
    },
    geometry: {
      type: "Point",
      coordinates: [106.693, 10.7769]
    }
  },
  {
    id: "feature_8",
    type: "Feature",
    place_type: ["address"],
    text: "123 L\xEA L\u1EE3i",
    place_name: "123 L\xEA L\u1EE3i, District 1, Ho Chi Minh City, Vietnam",
    properties: {
      name: "123 L\xEA L\u1EE3i",
      full_address: "123 L\xEA L\u1EE3i, District 1, Ho Chi Minh City, Vietnam",
      place_formatted: "123 L\xEA L\u1EE3i",
      address: "District 1, Ho Chi Minh City, Vietnam",
      mapbox_id: "dXJuOm1ieGFkZHI6ZmVhdHVyZS04",
      feature_type: "address"
    },
    geometry: {
      type: "Point",
      coordinates: [106.7012, 10.7756]
    }
  },
  {
    id: "feature_9",
    type: "Feature",
    place_type: ["poi"],
    text: "B\u1EBFn Th\xE0nh Market",
    place_name: "B\u1EBFn Th\xE0nh Market, District 1, Ho Chi Minh City, Vietnam",
    properties: {
      name: "B\u1EBFn Th\xE0nh Market",
      full_address: "B\u1EBFn Th\xE0nh Market, District 1, Ho Chi Minh City, Vietnam",
      place_formatted: "B\u1EBFn Th\xE0nh Market",
      address: "District 1, Ho Chi Minh City, Vietnam",
      mapbox_id: "dXJuOm1ieGFkZHI6ZmVhdHVyZS05",
      feature_type: "poi"
    },
    geometry: {
      type: "Point",
      coordinates: [106.698, 10.7725]
    }
  },
  {
    id: "feature_10",
    type: "Feature",
    place_type: ["locality"],
    text: "Ba \u0110\xECnh",
    place_name: "Ba \u0110\xECnh District, Hanoi, Vietnam",
    properties: {
      name: "Ba \u0110\xECnh",
      full_address: "Ba \u0110\xECnh District, Hanoi, Vietnam",
      place_formatted: "Ba \u0110\xECnh District",
      address: "Hanoi, Vietnam",
      mapbox_id: "dXJuOm1ieGFkZHI6ZmVhdHVyZS0xMA",
      feature_type: "locality"
    },
    geometry: {
      type: "Point",
      coordinates: [105.8237, 21.0313]
    }
  }
];

// src/options.ts
var mockOptions = [
  { value: "us", label: "United States", category: "North America" },
  { value: "ca", label: "Canada", category: "North America" },
  { value: "mx", label: "Mexico", category: "North America" },
  { value: "uk", label: "United Kingdom", category: "Europe" },
  { value: "fr", label: "France", category: "Europe" },
  { value: "de", label: "Germany", category: "Europe" },
  { value: "it", label: "Italy", category: "Europe" },
  { value: "jp", label: "Japan", category: "Asia" },
  { value: "cn", label: "China", category: "Asia" },
  { value: "au", label: "Australia", category: "Oceania" }
];
var technicalSkills = [
  { value: "javascript", label: "JavaScript" },
  { value: "python", label: "Python" },
  { value: "php", label: "PHP" },
  { value: "ux", label: "UX Designer" },
  { value: "sql", label: "SQL" },
  { value: "java", label: "Java" },
  { value: "html5", label: "HTML5" },
  { value: "ruby", label: "Ruby" }
];
var jobTitles = [
  {
    id: "1",
    name: "Software Engineer"
  },
  {
    id: "2",
    name: "Frontend Developer"
  },
  {
    id: "3",
    name: "Backend Developer"
  },
  {
    id: "4",
    name: "Full-Stack Developer"
  },
  {
    id: "5",
    name: "Mobile Developer (iOS/Android)"
  },
  {
    id: "6",
    name: "DevOps Engineer"
  },
  {
    id: "7",
    name: "Cloud Engineer"
  },
  {
    id: "8",
    name: "AI/ML Engineer"
  },
  {
    id: "9",
    name: "Data Engineer"
  },
  {
    id: "10",
    name: "Project Manager"
  },
  {
    id: "11",
    name: "Product Manager"
  },
  {
    id: "12",
    name: "Business Analyst (BA)"
  },
  {
    id: "13",
    name: "System Analyst"
  },
  {
    id: "14",
    name: "Product Owner"
  },
  {
    id: "15",
    name: "QA Engineer"
  },
  {
    id: "16",
    name: "Test Engineer"
  },
  {
    id: "17",
    name: "Automation Tester"
  },
  {
    id: "18",
    name: "Performance Tester"
  },
  {
    id: "19",
    name: "UI/UX Designer"
  },
  {
    id: "20",
    name: "Graphic Designer"
  },
  {
    id: "21",
    name: "Product Designer"
  }
];
var fieldsOfStudy = [
  {
    id: "1",
    name: "Computer Science"
  },
  {
    id: "2",
    name: "Software Engineering"
  },
  {
    id: "3",
    name: "Data Science"
  },
  {
    id: "4",
    name: "Artificial Intelligence & Machine Learning"
  },
  {
    id: "5",
    name: "Information Technology"
  },
  {
    id: "6",
    name: "Computer Engineering"
  }
];
var degrees = [
  {
    id: "1",
    name: "Bachelor\u2019s/Master\u2019s in Computer Science"
  },
  {
    id: "2",
    name: "Bachelor\u2019s/Master\u2019s in Software Engineering"
  },
  {
    id: "3",
    name: "Bachelor\u2019s/Master\u2019s in Information Technology"
  },
  {
    id: "4",
    name: "Bachelor\u2019s/Master\u2019s in Data Science"
  },
  {
    id: "5",
    name: "Bachelor\u2019s/Master\u2019s in Artificial Intelligence"
  },
  {
    id: "6",
    name: "Bachelor\u2019s in Computer Engineering"
  }
];
var schools = [
  {
    id: "1",
    name: "Da Nang University of Science and Technology (DUT - HUST DN)",
    metadata: {
      address: "54 Nguyen Luong Bang Street, Lien Chieu District, Danang City, Vietnam"
    }
  },
  {
    id: "2",
    name: "Duy Tan University",
    metadata: {
      address: "254 Nguyen Van Linh, Thanh Khe District, Danang City, Vietnam"
    }
  },
  {
    id: "3",
    name: "FPT University Da Nang",
    metadata: {
      address: "FPT University Campus, FPT City, Ngu Hanh Son District, Danang City, Vietnam"
    }
  },
  {
    id: "4",
    name: "Da Nang University of Education (UED-DN)",
    metadata: {
      address: "459 Ton Duc Thang Street, Lien Chieu District, Danang City, Vietnam"
    }
  },
  {
    id: "5",
    name: "Da Nang University of Economics (DUE-DN)",
    metadata: {
      address: "71 Ngu Hanh Son, Ngu Hanh Son District, Danang City, Vietnam"
    }
  },
  {
    id: "6",
    name: "Da Nang Architecture University",
    metadata: {
      address: "566 Nui Thanh, Hai Chau District, Danang City, Vietnam"
    }
  },
  {
    id: "7",
    name: "Vietnam - Korea Friendship IT College",
    metadata: {
      address: "470 Tran Dai Nghia, Ngu Hanh Son District, Danang City, Vietnam"
    }
  },
  {
    id: "8",
    name: "Da Nang FPT Polytechnic College",
    metadata: {
      address: "137 Nguyen Thi Thap Street, Lien Chieu District, Danang City, Vietnam"
    }
  },
  {
    id: "9",
    name: "Da Nang College of Economics and Planning",
    metadata: {
      address: "143 Nguyen Luong Bang Street, Lien Chieu District, Danang City, Vietnam"
    }
  },
  {
    id: "10",
    name: "Da Nang College of Commerce",
    metadata: {
      address: "45 Dung Sy Thanh Khe Street, Thanh Khe District, Da Nang City, Vietnam"
    }
  },
  {
    id: "11",
    name: "Passerelles num\xE9riques Vietnam (PNV)",
    metadata: {
      address: "99 To Hien Thanh Street, Son Tra District, Da Nang City, Vietnam"
    }
  }
];
var socialLinks = [
  { id: "1", name: "Facebook" },
  { id: "2", name: "GitHub" },
  { id: "3", name: "Instagram" },
  { id: "4", name: "Threads" },
  { id: "5", name: "TikTok" },
  { id: "6", name: "LinkedIn" }
];
var techSkills = [
  {
    id: "1",
    name: "Programming Languages",
    items: [
      "JavaScript",
      "TypeScript",
      "Python",
      "Java",
      "C++",
      "C#",
      "Ruby",
      "Go",
      "Rust"
    ]
  },
  {
    id: "2",
    name: "Frameworks & Libraries",
    items: [
      "React",
      "Angular",
      "Next.js",
      "Nuxt.js",
      "Django",
      "Flask",
      "FastAPI",
      "Spring Boot",
      "Express.js",
      "NestJS",
      "Laravel",
      "Ruby on Rails",
      "ASP.NET Core",
      "GraphQL"
    ]
  },
  {
    id: "3",
    name: "Databases",
    items: [
      "PostgreSQL",
      "MySQL",
      "MariaDB",
      "MongoDB",
      "Redis",
      "Firebase",
      "DynamoDB",
      "Neo4j",
      "Elasticsearch"
    ]
  },
  {
    id: "4",
    name: "Cloud & DevOps",
    items: [
      "AWS",
      "Azure",
      "Google Cloud",
      "DigitalOcean",
      "Docker",
      "Kubernetes",
      "Terraform",
      "Ansible",
      "Jenkins",
      "GitHub Actions",
      "GitLab CI/CD"
    ]
  },
  {
    id: "5",
    name: "Version Control",
    items: ["Git", "GitHub", "GitLab", "Bitbucket"]
  },
  {
    id: "6",
    name: "Testing & QA",
    items: [
      "Jest",
      "Cypress",
      "Selenium",
      "PyTest",
      "Mocha",
      "Chai",
      "Robot Framework",
      "Playwright",
      "TestCafe"
    ]
  },
  {
    id: "7",
    name: "Tools & Platforms",
    items: [
      "VS Code",
      "IntelliJ IDEA",
      "PyCharm",
      "Webpack",
      "Babel",
      "Figma",
      "Jira",
      "Confluence",
      "Notion",
      "Swagger",
      "Postman"
    ]
  },
  {
    id: "8",
    name: "Networking & Security",
    items: [
      "VPN",
      "Firewalls",
      "SSL/TLS",
      "OAuth",
      "SSO",
      "JWT",
      "OpenID Connect",
      "WAF",
      "Penetration Testing",
      "OWASP"
    ]
  },
  {
    id: "9",
    name: "Data Science",
    items: ["PyTorch", "Scikit-learn", "LangChain", "AI Agent"]
  },
  {
    id: "10",
    name: "AI & Machine Learning",
    items: ["TensorFlow", "Pandas", "NumPy"]
  },
  {
    id: "11",
    name: "Third-Party Services & APIs",
    items: [
      "Stripe",
      "Twilio",
      "SendGrid",
      "Algolia",
      "Sentry",
      "Auth0",
      "Unit",
      "Plaid",
      "PayPal",
      "Google Maps API",
      "OpenAI API"
    ]
  },
  {
    id: "12",
    name: "Mobile Development",
    items: ["Swift", "Kotlin", "React Native", "Flutter"]
  }
];
var certifications = [
  {
    category: "Organizations",
    items: [
      { id: "1", name: "Amazon Web Services" },
      { id: "2", name: "Google Cloud" },
      { id: "3", name: "Microsoft" },
      { id: "4", name: "Oracle" },
      { id: "5", name: "IBM" },
      { id: "6", name: "DeepLearning.AI" },
      { id: "7", name: "Scrum Alliance" },
      { id: "8", name: "PMI (Project Management Institute)" },
      { id: "9", name: "Scrum.org" }
    ]
  },
  {
    category: "Names",
    items: [
      { id: "10", name: "AWS Certified Solutions Architect" },
      { id: "11", name: "AWS Certified DevOps Engineer" },
      { id: "12", name: "AWS Certified Cloud Practitioner" },
      { id: "13", name: "AWS Certified Solutions Architect - Associate" },
      { id: "14", name: "AWS Certified Solutions Architect - Professional" },
      { id: "15", name: "AWS Certified Developer - Associate" },
      { id: "16", name: "AWS Certified SysOps Administrator - Associate" },
      { id: "17", name: "AWS Certified Advanced Networking - Specialty" },
      { id: "18", name: "AWS Certified Security - Specialty" },
      { id: "19", name: "AWS Certified Machine Learning - Specialty" },
      { id: "20", name: "AWS Certified Database - Specialty" },
      { id: "21", name: "AWS Certified Data Analytics - Specialty" },
      { id: "22", name: "AWS Certified SAP on AWS - Specialty" },
      {
        id: "23",
        name: "Google Cloud Certified: Professional Cloud Architect"
      },
      { id: "24", name: "Google Cloud Certified: Associate Cloud Engineer" },
      { id: "25", name: "Google Cloud Certified: Professional Data Engineer" },
      {
        id: "26",
        name: "Google Cloud Certified: Professional Cloud Developer"
      },
      {
        id: "27",
        name: "Google Cloud Certified: Professional Machine Learning Engineer"
      },
      {
        id: "28",
        name: "Google Cloud Certified: Professional Network Engineer"
      },
      {
        id: "29",
        name: "Google Cloud Certified: Professional Security Engineer"
      },
      { id: "30", name: "Project Management Professional (PMP)" },
      { id: "31", name: "Certified ScrumMaster (CSM)" },
      { id: "32", name: "Agile Certified Practitioner (PMI-ACP)" },
      { id: "33", name: "Professional Scrum Master I" },
      { id: "34", name: "Microsoft Certified: Azure Solutions Architect" },
      { id: "35", name: "Microsoft Certified: Azure Developer Associate" },
      { id: "36", name: "Oracle Certified Java Programmer" },
      { id: "37", name: "TensorFlow Developer Certificate" },
      { id: "38", name: "IBM Data Science Professional Certificate" },
      { id: "39", name: "AI for Everyone" },
      { id: "40", name: "TensorFlow Developer" }
    ]
  }
];

// src/personalInformation.ts
var MOCK_JOB_TITLE = [
  {
    label: "Software Engineer",
    value: "softwareEngineer"
  },
  {
    label: "Business Analyst",
    value: "businessAnalyst"
  },
  {
    label: "Quality Assurance",
    value: "qualityAssurance"
  }
];

// ../constants/dist/index.mjs
import { jsx } from "react/jsx-runtime";
import { jsx as jsx2 } from "react/jsx-runtime";
import { jsx as jsx3 } from "react/jsx-runtime";
import { jsx as jsx4, jsxs } from "react/jsx-runtime";
import { jsx as jsx5 } from "react/jsx-runtime";
import { jsx as jsx6 } from "react/jsx-runtime";
import { jsx as jsx7, jsxs as jsxs2 } from "react/jsx-runtime";
import { jsx as jsx8, jsxs as jsxs3 } from "react/jsx-runtime";
import { jsx as jsx9, jsxs as jsxs4 } from "react/jsx-runtime";
import { jsx as jsx10, jsxs as jsxs5 } from "react/jsx-runtime";
import { jsx as jsx11 } from "react/jsx-runtime";
import { jsx as jsx12 } from "react/jsx-runtime";
import { jsx as jsx13 } from "react/jsx-runtime";
var MAX_FILE_SIZE = 3 * 1024;
var MAX_IMAGE_DIMENSION = 1e4;
var INPUT_PHONE_NUMBER_LENGTH = 12;
var TextFormat = /* @__PURE__ */ ((TextFormat2) => {
  TextFormat2["BOLD"] = "bold";
  TextFormat2["ITALIC"] = "italic";
  TextFormat2["UNDERLINE"] = "underline";
  TextFormat2["CODE"] = "code";
  return TextFormat2;
})(TextFormat || {});
var BlockFormat = /* @__PURE__ */ ((BlockFormat2) => {
  BlockFormat2["PARAGRAPH"] = "paragraph";
  BlockFormat2["HEADING_1"] = "heading-1";
  BlockFormat2["HEADING_2"] = "heading-2";
  BlockFormat2["BLOCK_QUOTE"] = "block-quote";
  BlockFormat2["CODE_BLOCK"] = "code-block";
  BlockFormat2["BULLETED_LIST"] = "bulleted-list";
  BlockFormat2["NUMBERED_LIST"] = "numbered-list";
  BlockFormat2["LIST_ITEM"] = "list-item";
  BlockFormat2["LINK"] = "link";
  return BlockFormat2;
})(BlockFormat || {});
var ActionGroup = /* @__PURE__ */ ((ActionGroup22) => {
  ActionGroup22["RESUME"] = "resume";
  ActionGroup22["USER"] = "user";
  ActionGroup22["PROJECT"] = "project";
  ActionGroup22["EMPLOYEE"] = "employee";
  ActionGroup22["TRAINING"] = "training";
  ActionGroup22["MENU"] = "menu";
  ActionGroup22["STATISTIC"] = "statistic";
  return ActionGroup22;
})(ActionGroup || {});
var WorkPlace = /* @__PURE__ */ ((WorkPlace2) => {
  WorkPlace2["LH"] = "LH";
  WorkPlace2["NT"] = "604";
  WorkPlace2["HPT"] = "HPT";
  WorkPlace2["TL18"] = "TL18";
  WorkPlace2["HOME"] = "Home";
  return WorkPlace2;
})(WorkPlace || {});
var UserGroup = /* @__PURE__ */ ((UserGroup2) => {
  UserGroup2["CHEF"] = "chef";
  UserGroup2["KITCHEN_MANAGER"] = "kitchen_manager";
  UserGroup2["ON_BEHALF_MANAGER"] = "on_behalf_manager";
  UserGroup2["BGH"] = "bgh";
  UserGroup2["HF"] = "hf";
  return UserGroup2;
})(UserGroup || {});
var BoldIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "11",
    height: "15",
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1.52734 6.41243C0.975059 6.41243 0.527344 6.86015 0.527344 7.41243C0.527344 7.96472 0.975059 8.41243 1.52734 8.41243V6.41243ZM1.52734 13.2458H0.527344C0.527344 13.7981 0.975059 14.2458 1.52734 14.2458L1.52734 13.2458ZM1.52734 1.5791V0.579102C0.975059 0.579102 0.527344 1.02682 0.527344 1.5791L1.52734 1.5791ZM1.52734 7.41243V8.41243H6.11068V7.41243V6.41243H1.52734V7.41243ZM6.11068 13.2458V12.2458H1.52734V13.2458V14.2458H6.11068V13.2458ZM9.02734 10.3291H8.02734C8.02734 11.3876 7.16922 12.2458 6.11068 12.2458V13.2458V14.2458C8.27379 14.2458 10.0273 12.4922 10.0273 10.3291H9.02734ZM6.11068 7.41243V8.41243C7.16922 8.41243 8.02734 9.27056 8.02734 10.3291H9.02734H10.0273C10.0273 8.16599 8.27379 6.41243 6.11068 6.41243V7.41243ZM1.52734 1.5791V2.5791H5.27734V1.5791V0.579102H1.52734V1.5791ZM5.27734 7.41243V6.41243H1.52734V7.41243V8.41243H5.27734V7.41243ZM8.19401 4.49577H7.19401C7.19401 5.55431 6.33589 6.41243 5.27734 6.41243V7.41243V8.41243C7.44046 8.41243 9.19401 6.65888 9.19401 4.49577H8.19401ZM5.27734 1.5791V2.5791C6.33589 2.5791 7.19401 3.43722 7.19401 4.49577H8.19401H9.19401C9.19401 2.33265 7.44046 0.579102 5.27734 0.579102V1.5791ZM1.52734 1.5791H0.527344V13.2458H1.52734H2.52734V1.5791H1.52734Z",
        fill: "currentColor"
      }
    )
  }
);
var BoldIcon_default = BoldIcon;
var ItalicIcon = ({ ...props }) => /* @__PURE__ */ jsx2(
  "svg",
  {
    width: "10",
    height: "15",
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx2(
      "path",
      {
        d: "M1.52734 13.2458H4.86068M4.86068 1.5791H8.19401M3.19401 13.2458L6.52734 1.5791",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
var ItalicIcon_default = ItalicIcon;
var UnderlineIcon = ({ ...props }) => /* @__PURE__ */ jsx3(
  "svg",
  {
    width: "13",
    height: "15",
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx3(
      "path",
      {
        d: "M1.86035 13.2458H11.8604M3.52702 1.5791V6.5791C3.52702 8.42005 5.0194 9.91243 6.86035 9.91243C8.7013 9.91243 10.1937 8.42005 10.1937 6.5791V1.5791",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
var UnderlineIcon_default = UnderlineIcon;
var CodeIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "14",
    height: "10",
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx4(
        "path",
        {
          d: "M0.233484 5.41211L4.73348 9.91211L5.79297 8.85412L2.34871 5.41211L5.79297 1.97084L4.73423 0.912109L0.233484 5.41211Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx4(
        "path",
        {
          d: "M13.4872 5.41211L8.98722 0.912109L7.92773 1.9701L11.372 5.41211L7.92773 8.85337L8.98647 9.91211L13.4872 5.41211Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
var CodeIcon_default = CodeIcon;
var ListIcon = ({ ...props }) => /* @__PURE__ */ jsx5(
  "svg",
  {
    width: "14",
    height: "11",
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx5(
      "path",
      {
        d: "M4.36068 9.57845H12.694M4.36068 5.41178H12.694M4.36068 1.24512H12.694M1.02897 9.57845V9.58012L1.02734 9.58013V9.57845H1.02897ZM1.02897 5.41178V5.41345L1.02734 5.41346V5.41178H1.02897ZM1.02897 1.24512V1.24678L1.02734 1.2468V1.24512H1.02897Z",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
var ListOrderedIcon = ({ ...props }) => /* @__PURE__ */ jsx6(
  "svg",
  {
    width: "16",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx6(
      "path",
      {
        d: "M6.19336 12.5785H14.5267M1.19336 11.4829V11.3285C1.19336 10.6381 1.753 10.0785 2.44336 10.0785H2.47714C3.14884 10.0785 3.69345 10.623 3.69345 11.2947C3.69345 11.5871 3.59852 11.8716 3.42309 12.1055L1.19336 15.0785L3.69336 15.0785M6.19336 8.41178H14.5267M6.19336 4.24512H14.5267M1.19336 2.57845L2.86003 1.74512V6.74512",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
var ListOrderedIcon_default = ListOrderedIcon;
var QuoteIcon = ({ ...props }) => /* @__PURE__ */ jsxs2(
  "svg",
  {
    width: "11",
    height: "9",
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx7(
        "path",
        {
          d: "M2.50658 4.6227C1.36576 4.6227 0.595703 3.82859 0.595703 2.65211C0.595703 1.59329 1.47984 0.710938 2.6777 0.710938C3.98964 0.710938 4.95934 1.76976 4.95934 3.38741C4.95934 7.06388 2.27841 8.53447 0.595703 8.71094V7.09329C1.73652 6.88741 3.01995 5.74035 3.07699 4.47564C3.01994 4.50506 2.79178 4.6227 2.50658 4.6227Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx7(
        "path",
        {
          d: "M8.32476 4.6227C7.18394 4.6227 6.41388 3.82859 6.41388 2.65211C6.41388 1.59329 7.29802 0.710938 8.49588 0.710938C9.80782 0.710938 10.7775 1.76976 10.7775 3.38741C10.7775 7.06388 8.09659 8.53447 6.41388 8.71094V7.09329C7.5547 6.88741 8.83813 5.74035 8.89517 4.47564C8.83813 4.50506 8.60996 4.6227 8.32476 4.6227Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
var QuoteIcon_default = QuoteIcon;
var Heading1Icon = ({ ...props }) => /* @__PURE__ */ jsxs3(
  "svg",
  {
    width: "14",
    height: "12",
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx8(
        "path",
        {
          d: "M6.17285 0.912109V5.72461H2.04785V0.912109H0.672852V11.9121H2.04785V7.09961H6.17285V11.9121H7.54785V0.912109H6.17285Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx8(
        "path",
        {
          d: "M13.0479 11.9121V3.66211H12.0166L10.2979 4.12273V5.54586L11.6729 5.17736V11.9121H13.0479Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
var Heading1Icon_default = Heading1Icon;
var Heading2Icon = ({ ...props }) => /* @__PURE__ */ jsxs4(
  "svg",
  {
    width: "15",
    height: "12",
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx9(
        "path",
        {
          d: "M6.48535 0.912109V5.72461H2.36035V0.912109H0.985352V11.9121H2.36035V7.09961H6.48535V11.9121H7.86035V0.912109H6.48535Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx9(
        "path",
        {
          d: "M14.7354 6.24023C14.7354 4.81642 13.5041 3.66211 11.9854 3.66211C10.4666 3.66211 9.23535 4.81642 9.23535 6.24023H10.702L10.7064 6.14123C10.76 5.52317 11.3122 5.03711 11.9854 5.03711C12.6938 5.03711 13.2687 5.57611 13.2687 6.24023C13.2687 6.54205 13.1499 6.81842 12.9534 7.02948L9.23535 10.8424V11.9121H14.7354V10.5371H11.6436L14.0607 7.93148L14.1692 7.80773C14.5242 7.37323 14.7354 6.82942 14.7354 6.24023Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
var Heading2Icon_default = Heading2Icon;
var TerminalIcon = ({ ...props }) => /* @__PURE__ */ jsxs5(
  "svg",
  {
    width: "13",
    height: "12",
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx10(
        "path",
        {
          d: "M6.75936 5.29744L1.98454 0.522623L0.860352 1.64522L4.51496 5.29744L0.860352 8.94887L1.98375 10.0723L6.75936 5.29744Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx10(
        "rect",
        {
          x: "6.98047",
          y: "9.52832",
          width: "5.87928",
          height: "1.52318",
          fill: "currentColor"
        }
      )
    ]
  }
);
var TerminalIcon_default = TerminalIcon;
var getShortcut = (shortcut) => {
  if (typeof window === "undefined" || typeof navigator === "undefined")
    return "";
  const platform = navigator.userAgent || navigator.platform;
  const isMac = /Mac/i.test(platform);
  const isWindowsOrLinux = /Win/i.test(platform) || /Linux/i.test(platform);
  if (isMac) return `\u2318+${shortcut}`;
  if (isWindowsOrLinux) return `Ctrl+${shortcut}`;
  return "";
};
var TEXT_FORMATS = [
  {
    format: TextFormat.BOLD,
    icon: BoldIcon_default,
    label: "Bold",
    shortcut: getShortcut("B")
  },
  {
    format: TextFormat.ITALIC,
    icon: ItalicIcon_default,
    label: "Italic",
    shortcut: getShortcut("I")
  },
  {
    format: TextFormat.UNDERLINE,
    icon: UnderlineIcon_default,
    label: "Underline",
    shortcut: getShortcut("U")
  },
  {
    format: TextFormat.CODE,
    icon: CodeIcon_default,
    label: "Inline Code",
    shortcut: getShortcut("`")
  }
];
var BLOCK_FORMATS = [
  {
    format: BlockFormat.NUMBERED_LIST,
    icon: ListOrderedIcon_default,
    label: "Numbered List",
    shortcut: getShortcut("4")
  },
  {
    format: BlockFormat.BULLETED_LIST,
    icon: ListIcon,
    label: "Bullet List",
    shortcut: getShortcut("3")
  },
  {
    format: BlockFormat.HEADING_1,
    icon: Heading1Icon_default,
    label: "Heading 1",
    shortcut: getShortcut("1")
  },
  {
    format: BlockFormat.HEADING_2,
    icon: Heading2Icon_default,
    label: "Heading 2",
    shortcut: getShortcut("2")
  },
  {
    format: BlockFormat.CODE_BLOCK,
    icon: TerminalIcon_default,
    label: "Code Block",
    shortcut: getShortcut("L")
  },
  {
    format: BlockFormat.BLOCK_QUOTE,
    icon: QuoteIcon_default,
    label: "Quote",
    shortcut: getShortcut("Q")
  }
];
var MAX_CHARACTERS = {
  BIO: 300,
  DESCRIPTION: 5e3
};
var DEFAULT_RICH_TEXT_VALUE = [
  { type: BlockFormat.PARAGRAPH, children: [{ text: "" }] }
];
var MESSAGES = {
  // Form Messages
  FIELD_REQUIRED: (fieldName) => `Please enter your ${fieldName}.`,
  EMAIL_NOT_ALLOWED: (email) => `${email} is not allowed to access this application.`,
  UNKNOWN_ERROR: "An unknown error occurred. Please try again.",
  EMAIL_PASSWORD_INVALID: "Email or password is incorrect. Please try again.",
  // API Errors
  GENERAL_ERROR: "Something went wrong. Please try again later.",
  FETCH_OPTIONS_DATA_ERROR: "Failed to fetch the data option. Please try again later.",
  // Resumes
  RESUME_ID_MISSING: "Resume ID is missing.",
  // Personal Information
  FULLNAME_LENGTH: "Full Name must be no longer than 40 characters.",
  PHONE_NUMBER_LENGTH: `Phone number must be no longer than ${INPUT_PHONE_NUMBER_LENGTH} digits.`,
  EMAIL_LENGTH: "Email must be no longer than 60 characters.",
  JOB_TITLE_LENGTH: "Job title must be no longer than 32 characters.",
  ADDRESS_LENGTH: "Address must be no longer than 200 characters.",
  BIO_LENGTH: `Bio must be no longer than ${MAX_CHARACTERS.BIO} characters.`,
  DAY_OR_BIRTH_INVALID: "The day of birth is invalid.",
  DATE_OF_BIRTH_REQUIRED: "Please select your day of birth.",
  DATE_OF_BIRTH_FUTURE: "Day of birth cannot be in the future.",
  UNDER_MINIMUM_AGE: "You must be at least 18 years old.",
  OVER_MAXIMUM_AGE: "Please select a valid date of birth.",
  UPDATE_PERSONAL_INFO_FAILED: "Can't update personal information! Please try again.",
  UPDATE_PERSONAL_INFO_SUCCESS: "Your personal information has been saved successfully.",
  // Experience
  COMPANY_REQUIRED: "Please enter the company name.",
  PROJECT_NAME_LENGTH: "The project name must be no longer than 255 characters.",
  COMPANY_LENGTH: "Company name must be no longer than 50 characters.",
  JOB_TITLE_REQUIRED: "Please enter the job title.",
  DESCRIPTION_LENGTH: "Description must be no longer than 5000 characters.",
  RESPONSIBILITIES_LENGTH: "Responsibilities must be no longer than 5000 characters.",
  ROLE_LENGTH: "Role must be no longer than 50 characters.",
  ROLE_REQUIRED: "Please select a role.",
  ORDER: "The order is invalid.",
  TECH_STACK_DUPLICATE: "Duplicate categories are not allowed.",
  PROJECT_SKILL_CATEGORY_REQUIRED: "Please select a skill category.",
  PROJECT_TECHNICAL_SKILLS_REQUIRED: "Please at least select a skill.",
  UPDATE_EXPERIENCE_SUCCESS: "Your experience has been saved successfully.",
  // Education
  SCHOOL_NAME_LENGTH: "School name must be no longer than 100 characters.",
  SCHOOL_MAJOR_DUPLICATE: "Duplicate school and major combination are not allowed.",
  SCHOOL_LOCATION_LENGTH: "School location must be no longer than 200 characters.",
  DEGREE_LENGTH: "Degree/Program must be no longer than 50 characters.",
  MAJOR_LENGTH: "Major must be no longer than 100 characters.",
  UPDATE_EDUCATION_SUCCESS: "Your education has been saved successfully.",
  PHONE_NUMBER_VALID: "Please enter a valid phone number.",
  WEBHOOKS_RECEIVED: "Webhook received.",
  // QueryParams
  INVALID_LIMIT_PARAMS: "Invalid the limit query parameters.",
  INVALID_OFFSET_PARAMS: "Invalid offset query parameters.",
  // Start Date validations
  START_DATE_INVALID: "Please enter a valid start date.",
  START_DATE_LATER_THAN_END: "Start date cannot be later than the end date.",
  START_DATE_FUTURE: "Start date cannot be in the future.",
  START_DATE_REQUIRED: "Please select the start date.",
  // End Date validations
  END_DATE_REQUIRED: "Please select the end date.",
  END_DATE_INVALID: "Please enter a valid end date.",
  END_DATE_EARLIER_THAN_START: "End date cannot be earlier than the start date.",
  END_DATE_FUTURE: "End date cannot be in the future.",
  DATES_CANNOT_BE_SAME: "Start date and end date cannot be the same.",
  // Experience array validation
  MIN_EXPERIENCE_REQUIRED: "Please add at least one work experience.",
  // Education array validation
  MIN_EDUCATION_REQUIRED: "Please add at least one education.",
  // Technical Skills
  SKILL_CATEGORY_REQUIRED: "Please select a skill category.",
  SKILL_CATEGORY_DUPLICATE: "Duplicate categories are not allowed.",
  TECHNICAL_SKILLS_REQUIRED: "Please at least select a skill.",
  UPDATE_TECHNICAL_SKILLS_SUCCESS: "Your skills have been saved successfully.",
  // Contact info
  SOCIAL_URL_INVALID: "The url is invalid format.",
  SOCIAL_NAME_INVALID: "The name is invalid format.",
  SOCIAL_NAME_REQUIRED: "Please enter the social name.",
  SOCIAL_URL_REQUIRED: "Please enter the social url.",
  SOCIAL_NAME_LENGTH: "Social network name must be no longer than 50 characters.",
  SOCIAL_URL_LENGTH: "URL must be no longer than 255 characters.",
  SOCIAL_NAME_DUPLICATE: "Duplicate social links are not allowed.",
  // Certification
  CERTIFICATE_NAME_REQUIRED: "Please enter the certification name.",
  CERTIFICATE_NAME_LENGTH: "Certification name must be no longer than 255 characters.",
  CERTIFICATE_ISSUER_REQUIRED: "Please enter the issuing organization.",
  CERTIFICATE_ISSUER_LENGTH: "Issuing organization must be no longer than 250 characters.",
  CERTIFICATE_ISSUE_DATE_REQUIRED: "Please enter the issue date.",
  CERTIFICATE_ISSUE_DATE_IN_FUTURE: "Issue date cannot be in the future.",
  CREDENTIAL_URL_REQUIRED: "Please enter the credential url.",
  CREDENTIAL_URL_INVALID: "The credential url is invalid format.",
  CREDENTIAL_URL_LENGTH: "Credential url must be no longer than 262 characters.",
  UPDATE_CERTIFICATION_SUCCESS: "Your certifications have been saved successfully.",
  // Option data
  OPTION_DATA_CONTEXT_ERROR: "useOptionData must be used within OptionDataProvider.",
  // Address Autocomplete
  ADDRESS_AUTOCOMPLETE_SEARCHING: "Searching...",
  ADDRESS_AUTOCOMPLETE_NO_RESULTS: "No results found. You can still use the entered address.",
  ADDRESS_AUTOCOMPLETE_TYPE_TO_SEARCH: "Type to search for addresses",
  ADDRESS_AUTOCOMPLETE_PLACEHOLDER: "604 Nui Thanh",
  // Empty message autocomplete
  CATEGORIES_EMPTY: "No categories found",
  SKILL_EMPTY: "No skills found",
  // Empty message autocomplete
  ROLE_EMPTY: "No roles found",
  USER_EMPTY: "No users found",
  ADDITIONAL_ROLE_EMPTY: "No additional roles found",
  // Download by CMD/CTRL + K
  DOWNLOAD_RESUME_SUCCESS: "Resume has been downloaded successfully.",
  DOWNLOAD_RESUME_FAILED: "Failed to download the resume. Please try again.",
  // Training
  TRAINING_TOPIC_REQUIRED: "Please enter the training topic.",
  PRESENTATION_TITLE_REQUIRED: "Please enter the presentation title.",
  PRESENTATION_DATE_INVALID: "Please enter a valid presentation date.",
  PRESENTATION_DATE_PAST: "Presentation date cannot be in the past.",
  PRESENTATION_TIME_OUTSIDE_WORKING_HOURS: "Presentation time must be within working hours (8:00 AM to 5:30 PM).",
  PRESENTATION_DATE_LATER_THAN_EST_END: "Presentation date must be on or before the topic end date.",
  // Download video
  DOWNLOAD_VIDEO_SUCCESS: "Video downloaded successfully.",
  DOWNLOAD_VIDEO_FAILED: "Failed to download the video. Please try again."
};
var UPLOAD_FILE_MESSAGE = {
  EXCEED_FILE_SIZE: `File size exceeds the ${(MAX_FILE_SIZE / 1024).toFixed(0)}MB limit. Please choose a smaller file.`,
  EXCEED_GIVEN_FILE_SIZE: (fileSize) => `File size exceeds the ${fileSize}KB limit. Please choose a smaller file.`,
  INVALID_FILE_TYPE: (listFileType) => `File type not supported. Please upload the file with extensions: ${listFileType}.`,
  EXCEED_IMAGE_DIMENSION: `Image dimensions too large. Maximum allowed is ${MAX_IMAGE_DIMENSION}x${MAX_IMAGE_DIMENSION} pixels.`,
  CORRUPTED_IMAGE: "Failed to load image preview. The file might be corrupted."
};
var ROUTES = {
  // Auth
  SIGN_IN: "/signin",
  HOME: "/",
  // Projects
  PROJECTS: "/projects",
  // Employees
  EMPLOYEES: "/employees",
  // Trainings
  EMPLOYEE_TRAININGS: "/trainings",
  // User
  RESUMES: "/resumes",
  RESUME: "/resume",
  // CV Builder step
  PERSONAL_INFORMATION: "/personal-information",
  EXPERIENCES: "/experiences",
  TECHNICAL_SKILLS: "/technical-skills",
  EDUCATION: "/education",
  SOCIAL_LINKS: "/social-links",
  CERTIFICATES: "/certificates",
  PREVIEW: "/preview",
  NOT_FOUND: "/not-found"
};
var ResumeStep = {
  TEMPLATE_SELECTION: "TEMPLATE_SELECTION",
  PERSONAL_INFO: "PERSONAL_INFO",
  WORK_EXPERIENCE: "WORK_EXPERIENCE",
  SKILLS: "SKILLS",
  EDUCATION: "EDUCATION",
  SOCIAL_LINKS: "SOCIAL_LINKS",
  CERTIFICATIONS: "CERTIFICATIONS"
};
var STEP_TO_ROUTE = {
  [ResumeStep.TEMPLATE_SELECTION]: ROUTES.HOME,
  [ResumeStep.PERSONAL_INFO]: ROUTES.PERSONAL_INFORMATION,
  [ResumeStep.WORK_EXPERIENCE]: ROUTES.EXPERIENCES,
  [ResumeStep.SKILLS]: ROUTES.TECHNICAL_SKILLS,
  [ResumeStep.EDUCATION]: ROUTES.EDUCATION,
  [ResumeStep.SOCIAL_LINKS]: ROUTES.SOCIAL_LINKS,
  [ResumeStep.CERTIFICATIONS]: ROUTES.CERTIFICATES
};
var IMAGES = {
  DEFAULT: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQCKUbkvVbYTxHg_OQesfM8x6OoIbcMJSN3_w&s",
  LOGO_LIGHT_MODE: "/images/logo-light-mode.png",
  LOGO_DARK_MODE: "/images/logo-dark-mode.png",
  CV_TEMPLATE: "/images/cv-template.webp",
  AVATAR_DEFAULT: "/images/avatar.webp",
  AVATAR_DEFAULT_PNG: "/images/avatar.png",
  LANDING_BG: "/images/landing-background.webp",
  LANDING_BG_MOBILE: "/images/landing-bg-mobile.webp",
  LOGO_AGILITY: "/images/agility-logo.webp",
  APP_LOGO: "/images/app-logo.webp",
  LOGO_NOTFOUND: "/images/notfound-logo.webp",
  CHATBOT_PROCESSING: "/images/chatbot-processing.gif",
  LOGO_AGILITY_DARK_MODE: "/images/agility-logo-dark-mode.webp",
  SLOTH_SURFING: "/images/sloth-surfing.png"
};
var UserRole = /* @__PURE__ */ ((UserRole2) => {
  UserRole2["ADMIN"] = "admin";
  UserRole2["USER"] = "user";
  return UserRole2;
})(UserRole || {});
var UserStatus = /* @__PURE__ */ ((UserStatus2) => {
  UserStatus2["ACTIVE"] = "active";
  UserStatus2["INACTIVE"] = "inactive";
  return UserStatus2;
})(UserStatus || {});
var FirstLineIcon = ({ ...props }) => /* @__PURE__ */ jsx11(
  "svg",
  {
    width: "20",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx11(
      "path",
      {
        d: "M3.751 3.436c-.649.098-1.143.442-1.371.953-.195.438-.197.453-.197 2.244 0 1.473.007 1.675.06 1.882.178.696.613 1.13 1.309 1.309.206.053.408.059 1.865.059 1.45 0 1.659-.006 1.862-.058.696-.179 1.134-.616 1.312-1.31.053-.207.059-.408.059-1.865 0-1.454-.006-1.659-.059-1.863-.179-.697-.574-1.102-1.274-1.306-.176-.052-.39-.06-1.784-.067-.871-.004-1.673.005-1.782.022m7.599.461c-.36.166-.522.619-.354.989.073.16.273.335.437.383.077.023 1.18.031 3.219.024l3.103-.01.139-.092a.705.705 0 0 0 .333-.557c.017-.236-.034-.402-.172-.559-.225-.256 0-.24-3.472-.24-2.947 0-3.106.003-3.233.062M6.995 4.936c.078.028.113.067.14.159.023.081.032.629.025 1.629l-.01 1.508-.076.075-.076.076H3.835l-.076-.076-.076-.075-.01-1.508c-.011-1.636-.003-1.729.153-1.785.13-.048 3.032-.05 3.169-.003m4.355 3.127a.757.757 0 0 0-.354.989.81.81 0 0 0 .437.384c.077.022 1.18.03 3.219.024l3.103-.01.139-.092a.706.706 0 0 0 .333-.557c.017-.236-.034-.402-.172-.559-.225-.256 0-.241-3.472-.241-2.947 0-3.106.004-3.233.062M2.183 12.23c-.359.166-.521.619-.353.989a.8.8 0 0 0 .437.383c.078.023 2.673.031 7.802.024l7.686-.009.139-.092a.776.776 0 0 0 .306-.874.786.786 0 0 0-.383-.422c-.128-.058-.456-.061-7.817-.061-7.408 0-7.688.002-7.817.062m0 4.167c-.359.166-.521.619-.353.989a.8.8 0 0 0 .437.383c.078.023 2.673.031 7.802.024l7.686-.01.139-.092a.775.775 0 0 0 .306-.874.793.793 0 0 0-.383-.422c-.128-.058-.456-.06-7.817-.06-7.408 0-7.688.002-7.817.062",
        fillRule: "evenodd"
      }
    )
  }
);
var UserBoxIcon = (props) => /* @__PURE__ */ jsx12(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx12(
      "path",
      {
        d: "M17.028 0C21.396 0 24 2.604 24 6.972v10.056c0 3.37-1.548 5.686-4.272 6.563-.792.276-1.704.41-2.7.41H6.972c-.996 0-1.908-.132-2.7-.41C1.548 22.716 0 20.4 0 17.029V6.972C0 2.604 2.604 0 6.972 0zM12 17.962c-3.24 0-5.987 1.62-7.163 3.925h-.015l-.022-.011v.321h14.4v-.326l-.038.015C18 19.596 15.24 17.962 12 17.962M12 7.2a4.29 4.29 0 0 0-4.296 4.296A4.305 4.305 0 0 0 12 15.804a4.305 4.305 0 0 0 4.296-4.308A4.29 4.29 0 0 0 12 7.2",
        fill: "currentColor"
      }
    )
  }
);
var FileIcon = ({ ...props }) => /* @__PURE__ */ jsx13(
  "svg",
  {
    width: "16",
    height: "21",
    viewBox: "0 0 16 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx13("path", { d: "M14 20.5664H2C0.89543 20.5664 0 19.671 0 18.5664V2.56641C0 1.46184 0.89543 0.566406 2 0.566406H9C9.0109 0.566879 9.02167 0.568899 9.032 0.572406C9.04177 0.575423 9.05182 0.577434 9.062 0.578406C9.15019 0.584059 9.23726 0.601204 9.321 0.629406L9.349 0.638406C9.37167 0.646088 9.39373 0.655447 9.415 0.666406C9.52394 0.71483 9.62321 0.782591 9.708 0.866406L15.708 6.86641C15.7918 6.95119 15.8596 7.05046 15.908 7.15941C15.918 7.18141 15.925 7.20441 15.933 7.22741L15.942 7.25341C15.9699 7.3368 15.9864 7.42359 15.991 7.51141C15.9926 7.52059 15.9949 7.52962 15.998 7.53841C15.9998 7.54763 16.0004 7.55703 16.0001 7.56641V18.5664C16.0001 19.671 15.1046 20.5664 14 20.5664ZM2 2.56641V18.5664H14V8.56641H9C8.44772 8.56641 8 8.11869 8 7.56641V2.56641H2ZM10 3.98041V6.56641H12.586L10 3.98041Z" })
  }
);
var FileIcon_default = FileIcon;
var SEARCH_FORM_HEADING_ICONS = {
  [ActionGroup.RESUME]: FileIcon_default,
  [ActionGroup.USER]: UserBoxIcon,
  [ActionGroup.PROJECT]: FirstLineIcon
};
var DEFAULT_EMAIL_DOMAIN_LIST = [
  "@asnet.com.vn",
  "@agilityio.com"
];
var DEFAULT_EMAIL_DOMAIN = DEFAULT_EMAIL_DOMAIN_LIST[0];
var WORK_PLACES_TEXT = {
  [WorkPlace.LH]: "Lighthouse Building",
  [WorkPlace.NT]: "604 Nui Thanh",
  [WorkPlace.HPT]: "Ho Phi Tich",
  [WorkPlace.TL18]: "Trung Luong 18",
  [WorkPlace.HOME]: "Work from home"
};
var USER_GROUP_LABEL = {
  [UserGroup.BGH]: "big game hunter",
  [UserGroup.CHEF]: "chef",
  [UserGroup.HF]: "hell fire",
  [UserGroup.ON_BEHALF_MANAGER]: "on behalf manager",
  [UserGroup.KITCHEN_MANAGER]: "kitchen manager"
};

// src/resume.ts
var mockResume = {
  id: "john.doe@example.com",
  name: "Software Developer Resume",
  userId: "user-123",
  templateId: "template-modern-01",
  isSharable: true,
  createdAt: /* @__PURE__ */ new Date("2024-01-01"),
  updatedAt: /* @__PURE__ */ new Date("2024-03-22"),
  info: {
    id: "pi-123",
    name: "John Doe",
    email: "john.doe@example.com",
    phone: "+1 (555) 123-4567",
    bio: "Experienced software developer with a passion for creating efficient and scalable solutions.",
    title: "Senior Software Engineer",
    address: "123 Tech Street, San Francisco, CA 94105",
    avatar: "https://example.com/avatar.jpg",
    birthday: /* @__PURE__ */ new Date("1990-01-01")
  },
  journeys: [
    {
      id: "exp-1",
      company: "Tech Solutions Inc.",
      title: "Senior Software Engineer",
      address: "San Francisco, CA",
      start: /* @__PURE__ */ new Date("2020-01-01"),
      end: void 0,
      createdAt: /* @__PURE__ */ new Date("2024-01-01"),
      updatedAt: /* @__PURE__ */ new Date("2024-03-22"),
      projects: [
        {
          name: "Cloud SaaS Platform",
          desc: "Led development of a cloud-native SaaS platform for enterprise customers",
          role: "Tech Lead",
          duties: "Responsible for architecture, design, and implementation of core features",
          stacks: [
            {
              category: "Frontend",
              items: ["HTML", "CSS", "JavaScript", "React"]
            }
          ],
          start: /* @__PURE__ */ new Date("2022-01-01"),
          end: void 0
        },
        {
          name: "Mobile App Development",
          duties: "Developed a cross-platform mobile application using React Native",
          desc: "Redesigned authentication system improving security and performance",
          role: "Backend Developer",
          stacks: [
            {
              category: "Backend",
              items: ["C#", "Java", "Nodejs", "Spring"]
            }
          ],
          start: /* @__PURE__ */ new Date("2020-01-15"),
          end: /* @__PURE__ */ new Date("2021-12-31")
        }
      ]
    },
    {
      id: "exp-2",
      company: "Digital Innovations Ltd.",
      title: "Software Developer",
      address: "Boston, MA",
      start: /* @__PURE__ */ new Date("2018-03-01"),
      end: /* @__PURE__ */ new Date("2019-12-31"),
      createdAt: /* @__PURE__ */ new Date("2024-01-01"),
      updatedAt: /* @__PURE__ */ new Date("2024-03-22"),
      projects: [
        {
          name: "E-commerce Web Application",
          desc: "Developed and maintained multiple web applications for clients",
          duties: "Worked closely with designers and product managers to deliver high-quality software",
          role: "Full Stack Developer",
          stacks: [
            {
              category: "Frontend",
              items: ["HTML", "CSS", "JavaScript", "React"]
            }
          ],
          start: /* @__PURE__ */ new Date("2018-03-01"),
          end: /* @__PURE__ */ new Date("2019-12-31")
        }
      ]
    }
  ],
  skills: [
    {
      id: "skill-1",
      category: "Programming Languages",
      items: ["TypeScript", "JavaScript", "Python", "Java"],
      order: 1,
      createdAt: /* @__PURE__ */ new Date("2024-01-01"),
      updatedAt: /* @__PURE__ */ new Date("2024-03-22")
    },
    {
      id: "skill-2",
      category: "Frontend",
      items: ["React", "Redux", "HTML5", "CSS3", "SCSS"],
      order: 2,
      createdAt: /* @__PURE__ */ new Date("2024-01-01"),
      updatedAt: /* @__PURE__ */ new Date("2024-03-22")
    },
    {
      id: "skill-3",
      category: "Backend",
      items: ["Node.js", "Express", "GraphQL", "REST API"],
      order: 3,
      createdAt: /* @__PURE__ */ new Date("2024-01-01"),
      updatedAt: /* @__PURE__ */ new Date("2024-03-22")
    },
    {
      id: "skill-4",
      category: "Cloud & DevOps",
      items: ["AWS", "Docker", "Kubernetes", "CI/CD", "Terraform"],
      order: 4,
      createdAt: /* @__PURE__ */ new Date("2024-01-01"),
      updatedAt: /* @__PURE__ */ new Date("2024-03-22")
    }
  ],
  education: [
    {
      id: "edu-1",
      school: "University of Technology",
      address: "San Francisco, CA",
      degree: "Bachelor of Science",
      major: "Computer Science",
      admissionDate: /* @__PURE__ */ new Date("2014-09-01"),
      graduationDate: /* @__PURE__ */ new Date("2018-05-31"),
      createdAt: /* @__PURE__ */ new Date("2024-01-01"),
      updatedAt: /* @__PURE__ */ new Date("2024-03-22")
    }
  ],
  links: [
    {
      id: "social-1",
      name: "LinkedIn",
      url: "https://linkedin.com/in/johndoe",
      createdAt: /* @__PURE__ */ new Date("2024-01-01"),
      updatedAt: /* @__PURE__ */ new Date("2024-03-22")
    },
    {
      id: "social-2",
      name: "GitHub",
      url: "https://github.com/johndoe",
      createdAt: /* @__PURE__ */ new Date("2024-01-01"),
      updatedAt: /* @__PURE__ */ new Date("2024-03-22")
    },
    {
      id: "social-3",
      name: "Portfolio",
      url: "https://johndoe.dev",
      createdAt: /* @__PURE__ */ new Date("2024-01-01"),
      updatedAt: /* @__PURE__ */ new Date("2024-03-22")
    }
  ],
  certs: [
    {
      name: "AWS Certified Solutions Architect",
      org: "Amazon Web Services",
      issue: /* @__PURE__ */ new Date("2023-06-15"),
      url: "https://aws.amazon.com/certification/verify/12345"
    },
    {
      name: "Professional Scrum Master I",
      org: "Scrum.org",
      issue: /* @__PURE__ */ new Date("2022-09-10"),
      url: "https://www.scrum.org/certificates/123456"
    }
  ]
};
var MOCK_RESUMES = [
  {
    resume: mockResume,
    onEdit: () => {
    },
    onDownload: () => {
    },
    onShare: () => {
    },
    onDelete: () => {
    }
  },
  {
    resume: mockResume,
    onEdit: () => {
    },
    onDownload: () => {
    },
    onShare: () => {
    },
    onDelete: () => {
    }
  },
  {
    resume: mockResume,
    imageUrl: IMAGES.CV_TEMPLATE,
    onEdit: () => {
    },
    onDownload: () => {
    },
    onShare: () => {
    },
    onDelete: () => {
    }
  }
];

// src/string.ts
var EMAIL = {
  valid: "test@example.com",
  invalid: "test@example"
};
var PASSWORD = {
  valid: "StrongPass123!",
  invalid: "weak"
};

// src/templates.ts
var mockTemplateData = {
  info: {
    id: "1",
    name: "John Doe",
    email: "john.doe@example.com",
    phone: "+1 (555) 123-4567",
    address: "123 Main Street, San Francisco, CA 94105",
    bio: "<p>Experienced software engineer with over 8 years of expertise in front-end and back-end development. Passionate about creating efficient, scalable solutions and mentoring junior developers. Strong background in React, Node.js, and cloud technologies.</p>",
    title: "Senior Full-Stack Developer",
    birthday: "1990-05-15",
    previewImageBase64: "https://randomuser.me/api/portraits/men/32.jpg"
    // Replace with actual image or import
  },
  journeys: [
    {
      id: "exp1",
      company: "Tech Innovations Inc.",
      address: "San Francisco, CA",
      title: "Frontend Developer",
      start: "2019-06-01",
      end: "",
      order: 1,
      projects: [
        {
          id: "proj1",
          start: "2021-01-15",
          end: "2022-03-30",
          name: "Customer Portal Development",
          duties: "<ul><li>Developed user-friendly interfaces using React and TypeScript.</li><li>Collaborated with UX/UI designers to implement responsive designs.</li><li>Optimized application performance and reduced load times by 30%.</li></ul>",
          desc: "<p>Led the development of a customer-facing portal that increased user engagement by 45%. Implemented real-time analytics dashboard and optimized API performance.</p>",
          role: "Lead Developer",
          order: 1,
          stacks: [
            {
              category: "Frontend",
              items: ["React", "TypeScript", "Redux", "Material UI"],
              order: 1
            },
            {
              category: "Backend",
              items: ["Node.js", "Express", "MongoDB", "Redis"],
              order: 2
            },
            {
              category: "DevOps",
              items: ["Docker", "AWS", "CI/CD", "Kubernetes"],
              order: 3
            }
          ]
        },
        {
          id: "proj2",
          start: "2022-04-10",
          name: "E-commerce Platform Development",
          duties: "<ul><li>Architected and built a microservice-based e-commerce platform.</li><li>Implemented payment processing integration and inventory management system.</li><li>Collaborated with cross-functional teams to ensure seamless deployment.</li></ul>",
          end: "",
          desc: "<p>Architecting and building a microservice-based e-commerce platform supporting 50,000+ daily users. Implemented payment processing integration and inventory management system.</p>",
          role: "Technical Architect",
          order: 2,
          stacks: [
            {
              category: "Frontend",
              items: ["Next.js", "React", "TypeScript", "Tailwind CSS"],
              order: 1
            },
            {
              category: "Backend",
              items: ["NestJS", "PostgreSQL", "GraphQL", "RabbitMQ"],
              order: 2
            }
          ]
        }
      ]
    },
    {
      id: "exp2",
      company: "Digital Solutions LLC",
      address: "Boston, MA",
      title: "Full-Stack Developer",
      start: "2016-03-15",
      end: "2019-05-30",
      order: 2,
      projects: [
        {
          id: "proj3",
          start: "2017-07-01",
          name: "Internal Project Management Tool",
          duties: "<ul><li>Designed and implemented a project management tool for internal teams.</li><li>Integrated real-time collaboration features using WebSockets.</li><li>Conducted code reviews and mentored junior developers.</li></ul>",
          end: "2018-11-30",
          desc: "<p>Developed and launched a collaborative project management tool for internal teams that improved workflow efficiency by 30%.</p>",
          role: "Backend Developer",
          order: 1,
          stacks: [
            {
              category: "Technologies",
              items: ["Angular", "Node.js", "MySQL", "Socket.io"],
              order: 1
            }
          ]
        }
      ]
    }
  ],
  technicalSkills: [
    {
      name: "Programming Languages",
      items: ["JavaScript", "TypeScript", "Python", "Java", "SQL"]
    },
    {
      name: "Frontend",
      items: [
        "React",
        "Next.js",
        "Angular",
        "HTML5/CSS3",
        "Redux",
        "Tailwind CSS"
      ]
    },
    {
      name: "Backend",
      items: ["Node.js", "Express", "NestJS", "Django", "Spring Boot"]
    },
    {
      name: "Database",
      items: ["MongoDB", "PostgreSQL", "MySQL", "Redis", "Elasticsearch"]
    },
    {
      name: "DevOps & Tools",
      items: ["Git", "Docker", "Kubernetes", "AWS", "CI/CD", "Jest", "Cypress"]
    }
  ],
  educations: [
    {
      id: "edu1",
      school: "Massachusetts Institute of Technology",
      address: "Cambridge, MA",
      degree: "Master's",
      major: "Computer Science",
      admissionDate: "2014-09-01",
      graduationDate: "2016-05-30"
    },
    {
      id: "edu2",
      school: "University of California, Berkeley",
      address: "Berkeley, CA",
      degree: "Bachelor's",
      major: "Computer Engineering",
      admissionDate: "2010-09-01",
      graduationDate: "2014-05-30"
    }
  ],
  socialLinks: [
    {
      id: "social1",
      name: "LinkedIn",
      url: "https://linkedin.com/in/johndoe"
    },
    {
      id: "social2",
      name: "GitHub",
      url: "https://github.com/johndoe"
    },
    {
      id: "social3",
      name: "Twitter",
      url: "https://twitter.com/johndoe"
    },
    {
      id: "social4",
      name: "Portfolio",
      url: "https://johndoe.dev"
    }
  ],
  certs: [
    {
      name: "AWS Certified Solutions Architect",
      org: "Amazon Web Services",
      issue: "2022-03-15",
      url: "https://aws.amazon.com/verification/12345678"
    },
    {
      name: "Google Cloud Professional Developer",
      org: "Google",
      issue: "2021-06-10",
      url: "https://google.com/certifications/12345678"
    },
    {
      name: "MongoDB Certified Developer",
      org: "MongoDB Inc.",
      issue: "2020-11-22",
      url: "https://mongodb.com/certifications/12345678"
    }
  ]
};

// src/typography.ts
var SEMANTIC_ELEMENTS = [
  { as: "h1", size: "4xl", weight: "bold", label: "Main heading" },
  { as: "h2", size: "3xl", weight: "semibold", label: "Section heading" },
  { as: "h3", size: "2xl", weight: "medium", label: "Subsection heading" },
  { as: "h4", size: "xl", weight: "medium", label: "Subsection heading" },
  { as: "h5", size: "lg", weight: "medium", label: "Subsection heading" },
  { as: "h6", size: "md", weight: "medium", label: "Subsection heading" }
];
var SAMPLE_TEXTS = {
  SHORT: "The quick brown fox jumps over the lazy dog",
  MEDIUM: "This is a very long text that will be truncated with an ellipsis at the end because it exceeds the container width.",
  LONG: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
};

// src/user.ts
var mockClerkUser = {
  id: "user_3xz1DKfRcHnYpqwXyz45abcDEfg",
  passwordEnabled: true,
  totpEnabled: true,
  backupCodeEnabled: true,
  twoFactorEnabled: true,
  banned: false,
  locked: false,
  createdAt: 1742586123456,
  updatedAt: 1745612345678,
  imageUrl: "https://img.clerk.com/eyJ0eXBlIjoicHJveHkiLCJzcmMiOiJodHRwczovL2ltYWdlcy5jbGVyay5kZXYvb2F1dGhfZ2l0aHViL2ltZ18zeHoxREttcU5SNWFCOUpMdDM0TFpheXJQVHMifQ",
  hasImage: true,
  primaryEmailAddressId: "idn_3xz1DPjkLm23nBvcX45zAqrs7Ty",
  primaryPhoneNumberId: "idn_3xz1DQrst78uvWxYz12ABcde3Fg",
  primaryWeb3WalletId: null,
  lastSignIn: 1745610234567,
  externalId: "github-123456",
  username: "sarahparker",
  firstName: "Sarah",
  lastName: "Parker",
  fullName: "Sarah Parker",
  primaryEmailAddress: {
    id: "idn_3xz1DPjkLm23nBvcX45zAqrs7Ty",
    emailAddress: "sarah.parker@example.com"
  },
  primaryPhoneNumber: {
    id: "idn_3xz1DQrst78uvWxYz12ABcde3Fg",
    phoneNumber: "+15551234567"
  },
  primaryWeb3Wallet: null,
  raw: {
    id: "user_3xz1DKfRcHnYpqwXyz45abcDEfg",
    object: "user",
    username: "sarahparker",
    first_name: "Sarah",
    last_name: "Parker"
  },
  publicMetadata: {
    plan: "pro",
    teamId: "team_xyz123"
  },
  privateMetadata: {
    preferences: {
      theme: "dark",
      notifications: true
    }
  },
  unsafeMetadata: {},
  emailAddresses: [
    {
      id: "idn_3xz1DPjkLm23nBvcX45zAqrs7Ty",
      emailAddress: "sarah.parker@example.com",
      verification: {
        status: "verified",
        strategy: "email_code",
        externalVerificationRedirectURL: null,
        attempts: 1,
        expireAt: 1745610345678,
        nonce: null,
        message: null
      },
      linkedTo: [
        {
          id: "idn_3xz1DStUvWxy89zAbCdEfGh1Ijk",
          type: "oauth_github"
        }
      ]
    },
    {
      id: "idn_3xz1DVwXyzAbc12DeFgHiJk3Lmn",
      emailAddress: "sarahp@company.org",
      verification: {
        status: "verified",
        strategy: "email_code",
        externalVerificationRedirectURL: null,
        attempts: 1,
        expireAt: null,
        nonce: null,
        message: null
      },
      linkedTo: []
    }
  ],
  phoneNumbers: [
    {
      id: "idn_3xz1DQrst78uvWxYz12ABcde3Fg",
      phoneNumber: "+15551234567",
      verification: {
        status: "verified",
        strategy: "phone_code",
        externalVerificationRedirectURL: null,
        attempts: 1,
        expireAt: null,
        nonce: null,
        message: null
      },
      linkedTo: [],
      reservedForSecondFactor: false,
      defaultSecondFactor: false
    }
  ],
  web3Wallets: [],
  externalAccounts: [
    {
      id: "idn_3xz1DStUvWxy89zAbCdEfGh1Ijk",
      provider: "oauth_github",
      identificationId: "idn_3xz1DStUvWxy89zAbCdEfGh1Ijk",
      externalId: "456789",
      approvedScopes: "user:email read:user",
      emailAddress: "sarah.parker@example.com",
      firstName: "Sarah",
      lastName: "Parker",
      imageUrl: "https://img.clerk.com/eyJ0eXBlIjoicHJveHkiLCJzcmMiOiJodHRwczovL2F2YXRhcnMuZ2l0aHVidXNlcmNvbnRlbnQuY29tL3UvNDU2Nzg5P3Y9NCIsInMiOiJqTWtMcVAzNEZxR3pIeWJCZGtTaFJFNmN3UWN1ckxObTV6ZUJudDlIcmJNIn0",
      username: "sarahparker",
      publicMetadata: {},
      phoneNumber: "",
      label: null,
      verification: {
        status: "verified",
        strategy: "oauth_github",
        externalVerificationRedirectURL: null,
        attempts: null,
        expireAt: 1742586234567,
        nonce: null,
        message: null
      }
    }
  ],
  samlAccounts: [],
  lastActiveAt: 1745620123456,
  createOrganizationEnabled: true,
  createOrganizationsLimit: 5,
  deleteSelfEnabled: true,
  legalAcceptedAt: 17425862e5
};
var mockUsers = [
  {
    id: "john.doe@example.com",
    name: "John Doe",
    username: "john.doe",
    email: "john.doe@example.com",
    avatar: "https://randomuser.me/api/portraits/men/1.jpg",
    status: UserStatus.ACTIVE,
    role: UserRole.USER,
    lastSignIn: "2025-01-23T10:30:00.000Z",
    room: "LH-1",
    authId: "user_1",
    resources: {
      resumeId: "john.doe@example.com"
    }
  },
  {
    id: "jane.smith@example.com",
    name: "Jane Smith",
    username: "jane.smith",
    email: "jane.smith@example.com",
    avatar: "https://randomuser.me/api/portraits/women/2.jpg",
    status: UserStatus.INACTIVE,
    role: UserRole.USER,
    lastSignIn: "2025-01-22T15:45:00.000Z",
    room: "LH-2",
    authId: "user_2",
    resources: {
      resumeId: "jane.smith@example.com"
    }
  },
  {
    id: "bob.wilson@example.com",
    name: "Bob Wilson",
    email: "bob.wilson@example.com",
    status: UserStatus.ACTIVE,
    role: UserRole.USER,
    lastSignIn: "2025-01-23T09:15:00.000Z",
    room: "LH-3",
    authId: "user_3",
    resources: {
      resumeId: "bob.wilson@example.com"
    }
    // No username to test fallback
  }
];
var activeUser = mockUsers[0];
var inactiveUser = mockUsers[1];
var userWithoutUsername = mockUsers[2];

// ../types/dist/index.mjs
var ActionKind = /* @__PURE__ */ ((ActionKind2) => {
  ActionKind2["SUGGESTION"] = "suggestion";
  ActionKind2["REDIRECT"] = "redirect";
  ActionKind2["HANDLER"] = "handler";
  ActionKind2["ACTION"] = "action";
  ActionKind2["VALIDATION"] = "validation";
  return ActionKind2;
})(ActionKind || {});
var ActivityType = /* @__PURE__ */ ((ActivityType2) => {
  ActivityType2["ACTIVITY_UPDATE"] = "activity_update";
  ActivityType2["USER_ACTIVATE"] = "user_activate";
  ActivityType2["USER_DEACTIVATE"] = "user_deactivate";
  ActivityType2["USER_UPDATE_ROLE"] = "user_update_role";
  ActivityType2["EMPLOYEE_UPDATE_INFO"] = "employee_update_info";
  ActivityType2["EMPLOYEE_UPDATE_SKILLS"] = "employee_update_skills";
  ActivityType2["EMPLOYEE_UPDATE_PROFILE"] = "employee_update_profile";
  ActivityType2["EMPLOYEE_UPDATE_MY_PROFILE"] = "employee_update_my_profile";
  ActivityType2["EMPLOYEE_VIEW_PROFILE"] = "employee_view_profile";
  ActivityType2["EMPLOYEE_VIEW_MY_PROFILE"] = "employee_view_my_profile";
  ActivityType2["EMPLOYEE_ASSIGN_MENTOR"] = "employee_assign_mentor";
  ActivityType2["EMPLOYEE_ASSIGN_MENTEE"] = "employee_assign_mentee";
  ActivityType2["EMPLOYEE_UNASSIGN_MENTEE"] = "employee_unassign_mentee";
  ActivityType2["EMPLOYEE_UNASSIGN_MENTOR"] = "employee_unassign_mentor";
  ActivityType2["PROJECT_VIEW"] = "project_view";
  ActivityType2["PROJECT_CREATE"] = "project_create";
  ActivityType2["PROJECT_UPDATE"] = "project_update";
  ActivityType2["PROJECT_KICK_OFF"] = "project_kick_off";
  ActivityType2["PROJECT_RELEASE"] = "project_release";
  ActivityType2["PROJECT_PAUSE"] = "project_pause";
  ActivityType2["PROJECT_RESUME"] = "project_resume";
  ActivityType2["PROJECT_GO_LIVE"] = "project_go_live";
  ActivityType2["PROJECT_COMPLETE"] = "project_complete";
  ActivityType2["PROJECT_MEMBER_JOIN"] = "project_member_join";
  ActivityType2["PROJECT_MEMBER_ROLE_CHANGE"] = "project_member_role_change";
  ActivityType2["PROJECT_MEMBER_LEAVE"] = "project_member_leave";
  ActivityType2["PROJECT_MEMBER_RESUME"] = "project_member_resume";
  ActivityType2["PROJECT_MEMBER_REMOVE"] = "project_member_remove";
  ActivityType2["PROJECT_ARCHIVE"] = "project_archive";
  ActivityType2["PROJECT_UNARCHIVE"] = "project_unarchive";
  ActivityType2["PROJECT_SCHEDULE_ACTIVITY"] = "project_schedule_activity";
  ActivityType2["TRAINING_CREATE"] = "training_create";
  ActivityType2["TRAINING_UPDATE"] = "training_update";
  ActivityType2["TRAINING_VIEW"] = "training_view";
  ActivityType2["TRAINING_START"] = "training_start";
  ActivityType2["TRAINING_COMPLETE"] = "training_complete";
  ActivityType2["TRAINING_PAUSE"] = "training_pause";
  ActivityType2["TRAINING_RESUME"] = "training_resume";
  ActivityType2["TRAINING_FEEDBACK_RECEIVED"] = "training_feedback";
  ActivityType2["TRAINING_FEEDBACK_PRESENTATION"] = "training_feedback_presentation";
  ActivityType2["TRAINING_ASSIGN_SUPPORTER"] = "training_assign_supporter";
  ActivityType2["TRAINING_UNASSIGN_SUPPORTER"] = "training_unassign_supporter";
  ActivityType2["TRAINING_ASSIGN_TRAINEE"] = "training_assign_trainee";
  ActivityType2["TRAINING_PRESENTATION"] = "training_presentation";
  ActivityType2["TRAINING_UPDATE_PRESENTATION"] = "training_update_presentation";
  ActivityType2["TRAINING_REQUEST_FEEDBACK_PRESENTATION"] = "training_request_feedback_presentation";
  ActivityType2["TRAINING_UPDATE_FEEDBACK"] = "training_update_feedback";
  ActivityType2["TRAINING_UPDATE_FEEDBACK_PRESENTATION"] = "training_update_feedback_presentation";
  ActivityType2["TRAINING_UNASSIGN_PARTICIPANT"] = "training_unassign_participant";
  ActivityType2["TRAINING_ARCHIVE"] = "training_archive";
  ActivityType2["TRAINING_UNARCHIVE"] = "training_unarchive";
  ActivityType2["TRAINING_ARCHIVE_PRESENTATION"] = "training_archive_presentation";
  ActivityType2["TRAINING_UNARCHIVE_PRESENTATION"] = "training_unarchive_presentation";
  ActivityType2["TICKET_APPROVE"] = "ticket_approve";
  ActivityType2["TICKET_REJECT"] = "ticket_reject";
  ActivityType2["TICKET_PENDING"] = "ticket_pending";
  ActivityType2["TICKET_DONE"] = "ticket_done";
  ActivityType2["TICKET_CLOSE"] = "ticket_close";
  ActivityType2["TICKET_REALLOCATION"] = "ticket_reallocation";
  ActivityType2["TICKET_ROOM_BOOKING"] = "ticket_room_booking";
  ActivityType2["TICKET_TIME_OFF"] = "ticket_time_off";
  ActivityType2["TICKET_MAINTENANCE"] = "ticket_maintenance";
  ActivityType2["TICKET_LUNCH_REGISTRATION"] = "ticket_lunch_registration";
  ActivityType2["TICKET_ON_BEHALF_LUNCH_REGISTRATION"] = "ticket_on_behalf_lunch_registration";
  ActivityType2["TICKET_ON_BEHALF_TIME_OFF"] = "ticket_on_behalf_time_off";
  ActivityType2["RESUME_VIEW_MY"] = "resume_view_my";
  ActivityType2["RESUME_DOWNLOAD_MY"] = "resume_download_my";
  ActivityType2["RESUME_DOWNLOAD_MY_DOCX"] = "resume_download_my_docx";
  ActivityType2["RESUME_UPDATE_MY"] = "resume_update_my";
  ActivityType2["RESUME_VIEW"] = "resume_view";
  ActivityType2["RESUME_CREATE"] = "resume_create";
  ActivityType2["RESUME_DOWNLOAD"] = "resume_download";
  ActivityType2["VIEW_MENU"] = "view_menu";
  ActivityType2["VIEW_STATISTIC"] = "view_statistic";
  ActivityType2["COMPARE_STATISTIC"] = "compare_statistic";
  ActivityType2["RESUME_DOWNLOAD_DOCX"] = "resume_download_docx";
  return ActivityType2;
})(ActivityType || {});
var ActionGroup2 = /* @__PURE__ */ ((ActionGroup22) => {
  ActionGroup22["RESUME"] = "resume";
  ActionGroup22["USER"] = "user";
  ActionGroup22["PROJECT"] = "project";
  ActionGroup22["EMPLOYEE"] = "employee";
  ActionGroup22["TRAINING"] = "training";
  ActionGroup22["MENU"] = "menu";
  ActionGroup22["STATISTIC"] = "statistic";
  return ActionGroup22;
})(ActionGroup2 || {});
var MemberStatus = /* @__PURE__ */ ((MemberStatus2) => {
  MemberStatus2["JOINED"] = "joined";
  MemberStatus2["RESUMED"] = "resumed";
  MemberStatus2["LEFT"] = "left";
  MemberStatus2["PAUSED"] = "paused";
  MemberStatus2["COMPLETED"] = "completed";
  return MemberStatus2;
})(MemberStatus || {});
var ProjectMemberAdditionalRole = /* @__PURE__ */ ((ProjectMemberAdditionalRole2) => {
  ProjectMemberAdditionalRole2["SUPPORTER"] = "supporter";
  ProjectMemberAdditionalRole2["HOT_TRAINING"] = "hot_training";
  ProjectMemberAdditionalRole2["SHADOW"] = "shadow";
  return ProjectMemberAdditionalRole2;
})(ProjectMemberAdditionalRole || {});

// src/action.tsx
var mockActionItems = [
  {
    type: ActivityType.RESUME_VIEW_MY,
    kind: ActionKind.REDIRECT,
    label: "View my resume",
    desc: "View your own resume",
    identity: "john@gmail.com",
    group: ActionGroup2.RESUME
  },
  {
    type: ActivityType.RESUME_UPDATE_MY,
    kind: ActionKind.REDIRECT,
    label: "Edit my resume",
    desc: "Edit your current resume",
    identity: "john12@gmail.com",
    group: ActionGroup2.RESUME
  },
  {
    type: ActivityType.RESUME_DOWNLOAD_MY,
    kind: ActionKind.HANDLER,
    label: "Download my resume",
    desc: "Download a copy of your resume as PDF",
    identity: "john123@gmail.com",
    group: ActionGroup2.RESUME
  },
  {
    type: ActivityType.RESUME_DOWNLOAD_MY_DOCX,
    kind: ActionKind.HANDLER,
    label: "Download my resume as Docx",
    desc: "Download a copy of your resume as DOCX",
    identity: "john123@gmail.com",
    group: ActionGroup2.RESUME
  },
  {
    type: ActivityType.RESUME_VIEW,
    kind: ActionKind.REDIRECT,
    label: "View @someone's resume",
    desc: "View another user's resume",
    identity: "golden@gmail.com",
    group: ActionGroup2.RESUME
  },
  {
    type: ActivityType.RESUME_VIEW,
    kind: ActionKind.HANDLER,
    label: "View all users",
    desc: "View all users in the system",
    identity: "golden12@gmail.com",
    group: ActionGroup2.USER
  },
  {
    type: ActivityType.USER_ACTIVATE,
    kind: ActionKind.HANDLER,
    label: "Activate user account",
    desc: "Activate a disabled user account",
    identity: "golden123@gmail.com",
    group: ActionGroup2.USER
  },
  {
    type: ActivityType.USER_DEACTIVATE,
    kind: ActionKind.HANDLER,
    label: "Deactivate user account",
    desc: "Temporarily disable a user account",
    identity: "golden1234@gmail.com",
    group: ActionGroup2.USER
  }
];

// src/project.ts
var mockSampleDateStatusList = [
  {
    date: /* @__PURE__ */ new Date("2025-06-20"),
    type: "START_DATE"
  },
  {
    date: /* @__PURE__ */ new Date("2025-06-25"),
    type: "END_DATE"
  },
  {
    date: /* @__PURE__ */ new Date("2025-06-22"),
    type: "LEFT_DATE"
  }
];
var mockMultipleDateStatusList = [
  {
    date: /* @__PURE__ */ new Date("2025-06-10"),
    type: "START_DATE"
  },
  {
    date: /* @__PURE__ */ new Date("2025-06-15"),
    type: "RESUME_DATE"
  },
  {
    date: /* @__PURE__ */ new Date("2025-06-20"),
    type: "LEFT_DATE"
  },
  {
    date: /* @__PURE__ */ new Date("2025-06-25"),
    type: "END_DATE"
  }
];
var mockMembers = [
  {
    id: "9bde4341-3436-408d-8711-b05a5d30cbad",
    username: "emily@example.com",
    status: MemberStatus.JOINED,
    role: "Senior Frontend Engineer",
    avatar: "https://i.pravatar.cc/50?img=9",
    name: "Emily Chen"
  },
  {
    id: "83e3c7fa-c1ef-43e2-8e12-b442c5078e22",
    username: "michael@example.com",
    avatar: "https://i.pravatar.cc/50?img=10",
    status: MemberStatus.JOINED,
    name: "Michael Rodriguez",
    role: "DevOps Engineer",
    tag: ProjectMemberAdditionalRole.SUPPORTER
  },
  {
    id: "5e8c7fa-c1ef-43e2-8e12-b442c5078e45",
    username: "sarah@example.com",
    status: MemberStatus.LEFT,
    name: "Sarah Johnson",
    avatar: "https://i.pravatar.cc/50?img=11",
    role: "UX/UI Designer"
  },
  {
    id: "9h8g7f6e-5d4c-3b2a-1z9y-8x7w6v5u4t3s",
    username: "james@example.com",
    status: MemberStatus.LEFT,
    name: "James Wilson",
    avatar: "https://i.pravatar.cc/50?img=12",
    role: "Product Manager"
  }
];
var mockProjectActivities = [
  {
    id: "event-12",
    type: ActivityType.PROJECT_COMPLETE,
    group: ActionGroup2.PROJECT,
    occurredAt: "2025-01-15T17:00:00.000Z",
    data: {
      project: "project-1",
      desc: "<strong>Project successfully completed</strong> with all planned deliverables achieved including <em>full-featured e-commerce platform</em> with advanced functionality and optimal performance."
    }
  },
  {
    id: "event-11",
    type: ActivityType.PROJECT_GO_LIVE,
    group: ActionGroup2.PROJECT,
    occurredAt: "2024-12-10T00:00:00.000Z",
    data: {
      project: "project-1",
      desc: "<strong>E-Commerce platform officially went live</strong> for public users with comprehensive launch strategy including <em>soft launch, gradual rollout, and full production deployment</em>."
    }
  },
  {
    id: "event-10",
    type: ActivityType.PROJECT_RELEASE,
    group: ActionGroup2.PROJECT,
    occurredAt: "2024-11-25T12:00:00.000Z",
    data: {
      project: "project-1",
      desc: "<strong>Production version 2.0.0 successfully released</strong> with significantly enhanced features and improved user experience based on <em>beta testing feedback</em>."
    }
  },
  {
    id: "event-9",
    type: ActivityType.PROJECT_RESUME,
    group: ActionGroup2.PROJECT,
    occurredAt: "2024-10-15T09:00:00.000Z",
    data: {
      project: "project-1",
      desc: "<strong>Project successfully resumed</strong> with enhanced team structure and updated timeline incorporating <em>lessons learned from initial development phase</em>."
    }
  },
  {
    id: "event-8",
    type: ActivityType.PROJECT_PAUSE,
    group: ActionGroup2.PROJECT,
    occurredAt: "2024-09-10T11:00:00.000Z",
    data: {
      project: "project-1",
      desc: "<strong>Project temporarily paused</strong> due to strategic resource reallocation and organizational restructuring to <em>optimize development efficiency</em>."
    }
  },
  {
    id: "event-7",
    type: ActivityType.PROJECT_MEMBER_LEAVE,
    group: ActionGroup2.PROJECT,
    occurredAt: "2024-08-05T16:20:00.000Z",
    data: {
      user: "sarah@example.com",
      project: "project-1",
      name: "Sarah Johnson",
      role: "UX/UI Designer"
    }
  },
  {
    id: "event-6",
    type: ActivityType.PROJECT_RELEASE,
    group: ActionGroup2.PROJECT,
    occurredAt: "2024-07-20T16:00:00.000Z",
    data: {
      project: "project-1",
      desc: "<strong>Beta version 1.0.0 successfully released</strong> for comprehensive internal testing phase with <em>core functionality implementation completed</em>."
    }
  },
  {
    id: "event-5",
    type: ActivityType.PROJECT_MEMBER_LEAVE,
    group: ActionGroup2.PROJECT,
    occurredAt: "2024-06-15T14:30:00.000Z",
    data: {
      user: "james@example.com",
      project: "project-1",
      name: "James Wilson",
      role: "Product Manager"
    }
  },
  {
    id: "event-4",
    type: ActivityType.PROJECT_KICK_OFF,
    group: ActionGroup2.PROJECT,
    occurredAt: "2024-03-15T09:00:00.000Z",
    data: {
      project: "project-1",
      desc: "<strong>Official project kickoff meeting</strong> conducted with all key stakeholders including <em>product owners, technical leads, and business representatives</em>."
    }
  },
  {
    id: "event-3",
    type: ActivityType.PROJECT_MEMBER_JOIN,
    group: ActionGroup2.PROJECT,
    occurredAt: "2024-03-10T10:00:00.000Z",
    data: {
      user: "emily@example.com",
      project: "project-1",
      status: MemberStatus.JOINED,
      role: "Senior Frontend Engineer",
      name: "Emily Chen",
      avatar: "https://i.pravatar.cc/50?img=9"
    }
  },
  {
    id: "event-2",
    type: ActivityType.PROJECT_MEMBER_JOIN,
    group: ActionGroup2.PROJECT,
    occurredAt: "2024-03-08T14:30:00.000Z",
    data: {
      user: "michael@example.com",
      project: "project-1",
      status: MemberStatus.JOINED,
      role: "DevOps Engineer",
      name: "Michael Rodriguez",
      avatar: "https://i.pravatar.cc/50?img=10",
      tag: ProjectMemberAdditionalRole.SUPPORTER
    }
  },
  {
    id: "event-1",
    type: ActivityType.PROJECT_CREATE,
    group: ActionGroup2.PROJECT,
    occurredAt: "2024-03-01T08:00:00.000Z",
    data: {
      project: "project-1",
      desc: "<strong>E-Commerce Platform Development Project</strong> created with comprehensive scope including <em>user authentication, product catalog, shopping cart, payment integration, and admin dashboard</em>."
    }
  }
];

// src/timeOffRequest.ts
var timeOffRequestMocks = [
  // ==================== APPROVED REQUESTS ====================
  /**
   * Multi-day vacation request - fully approved by all recipients
   */
  {
    id: "time-off-001",
    start: "2025-12-03T08:00:00Z",
    end: "2025-12-05T17:30:00Z",
    reason: "Winter vacation - family trip to ski resort. Will be available for urgent matters via email.",
    status: "approved",
    recipients: [
      {
        user: "sarah.johnson@company.com",
        name: "Sarah Johnson",
        avatarUrl: "https://randomuser.me/api/portraits/men/1.jpg",
        status: "approved",
        actionAt: "2025-11-28T16:45:00Z"
      },
      {
        user: "mike.chen@company.com",
        name: "Mike Chen",
        avatarUrl: "https://randomuser.me/api/portraits/women/2.jpg",
        status: "approved",
        actionAt: "2025-11-29T09:20:00Z"
      }
    ]
  },
  /**
   * Half-day morning request - single approver
   */
  {
    id: "time-off-002",
    start: "2025-11-25T08:00:00Z",
    end: "2025-11-25T12:00:00Z",
    reason: "Doctor appointment in the morning. Will return after lunch.",
    status: "approved",
    recipients: [
      {
        user: "sarah.johnson@company.com",
        name: "Sarah Johnson",
        avatarUrl: "https://randomuser.me/api/portraits/men/1.jpg",
        status: "approved",
        actionAt: "2025-11-23T10:30:00Z"
      }
    ]
  },
  /**
   * Full day personal time - quick approval
   */
  {
    id: "time-off-003",
    start: "2025-11-20T08:00:00Z",
    end: "2025-11-20T17:30:00Z",
    reason: "Personal matter - family business to handle.",
    status: "approved",
    recipients: [
      {
        user: "sarah.johnson@company.com",
        name: "Sarah Johnson",
        avatarUrl: "https://randomuser.me/api/portraits/men/1.jpg",
        status: "approved",
        actionAt: "2025-11-19T14:00:00Z"
      }
    ]
  },
  /**
   * Conference attendance - multiple approvers
   */
  {
    id: "time-off-004",
    start: "2025-10-09T08:00:00Z",
    end: "2025-10-11T17:30:00Z",
    reason: "Attending React Conf 2025 in San Francisco. Will gain valuable industry insights and return with learnings.",
    status: "approved",
    recipients: [
      {
        user: "sarah.johnson@company.com",
        name: "Sarah Johnson",
        avatarUrl: "https://randomuser.me/api/portraits/men/1.jpg",
        status: "approved",
        actionAt: "2025-09-25T09:15:00Z"
      },
      {
        user: "mike.chen@company.com",
        name: "Mike Chen",
        avatarUrl: "https://randomuser.me/api/portraits/women/2.jpg",
        status: "approved",
        actionAt: "2025-09-25T10:30:00Z"
      },
      {
        user: "emily.davis@company.com",
        name: "Emily Davis",
        avatarUrl: "https://randomuser.me/api/portraits/men/2.jpg",
        status: "approved",
        actionAt: "2025-09-25T16:45:00Z"
      }
    ]
  },
  /**
   * Extended weekend getaway
   */
  {
    id: "time-off-005",
    start: "2025-10-17T13:30:00Z",
    end: "2025-10-20T17:30:00Z",
    reason: "Extended weekend for family reunion in another city.",
    status: "approved",
    recipients: [
      {
        user: "sarah.johnson@company.com",
        name: "Sarah Johnson",
        avatarUrl: "https://randomuser.me/api/portraits/men/1.jpg",
        status: "approved",
        actionAt: "2025-10-10T11:20:00Z"
      },
      {
        user: "mike.chen@company.com",
        name: "Mike Chen",
        avatarUrl: "https://randomuser.me/api/portraits/women/2.jpg",
        status: "approved",
        actionAt: "2025-10-10T14:15:00Z"
      }
    ]
  },
  /**
   * Sick leave - single day
   */
  {
    id: "time-off-006",
    start: "2025-09-15T08:00:00Z",
    end: "2025-09-15T17:30:00Z",
    reason: "Not feeling well. Will work from home or take rest as needed.",
    status: "approved",
    recipients: [
      {
        user: "sarah.johnson@company.com",
        name: "Sarah Johnson",
        avatarUrl: "https://randomuser.me/api/portraits/men/1.jpg",
        status: "approved",
        actionAt: "2025-09-15T08:15:00Z"
      }
    ]
  },
  // ==================== REJECTED REQUESTS ====================
  /**
   * Rejected morning request - single approver denied
   */
  {
    id: "time-off-007",
    start: "2025-11-18T08:00:00Z",
    end: "2025-11-18T12:00:00Z",
    reason: "Had to cancel - urgent project deadline.",
    status: "rejected",
    recipients: [
      {
        user: "sarah.johnson@company.com",
        name: "Sarah Johnson",
        avatarUrl: "https://randomuser.me/api/portraits/men/1.jpg",
        status: "rejected",
        actionAt: "2025-11-16T15:30:00Z"
      }
    ]
  },
  /**
   * Rejected multi-day request - conflicting with company event
   */
  {
    id: "time-off-008",
    start: "2025-12-15T08:00:00Z",
    end: "2025-12-17T17:30:00Z",
    reason: "Cancelled due to company event conflict.",
    status: "rejected",
    recipients: [
      {
        user: "sarah.johnson@company.com",
        name: "Sarah Johnson",
        avatarUrl: "https://randomuser.me/api/portraits/men/1.jpg",
        status: "rejected",
        actionAt: "2025-12-10T13:00:00Z"
      },
      {
        user: "mike.chen@company.com",
        name: "Mike Chen",
        avatarUrl: "https://randomuser.me/api/portraits/women/2.jpg",
        status: "rejected",
        actionAt: "2025-12-10T14:30:00Z"
      }
    ]
  },
  /**
   * Rejected request - partially rejected by one approver
   * Note: Status is rejected if ANY recipient rejected
   */
  {
    id: "time-off-009",
    start: "2025-10-30T08:00:00Z",
    end: "2025-10-31T17:30:00Z",
    reason: "Project milestone - cannot approve.",
    status: "rejected",
    recipients: [
      {
        user: "sarah.johnson@company.com",
        name: "Sarah Johnson",
        avatarUrl: "https://randomuser.me/api/portraits/men/1.jpg",
        status: "approved",
        actionAt: "2025-10-25T09:00:00Z"
      },
      {
        user: "mike.chen@company.com",
        name: "Mike Chen",
        avatarUrl: "https://randomuser.me/api/portraits/women/2.jpg",
        status: "rejected",
        actionAt: "2025-10-25T10:15:00Z"
      }
    ]
  },
  // ==================== WAITING FOR APPROVAL ====================
  /**
   * Pending request - no recipients have responded yet
   */
  {
    id: "time-off-010",
    start: "2025-12-10T08:00:00Z",
    end: "2025-12-12T17:30:00Z",
    reason: "Holiday break - celebrating with family.",
    status: "waiting_for_approve",
    recipients: [
      {
        user: "sarah.johnson@company.com",
        name: "Sarah Johnson",
        avatarUrl: "https://randomuser.me/api/portraits/men/1.jpg",
        status: "waiting_for_approve",
        actionAt: null
      },
      {
        user: "mike.chen@company.com",
        name: "Mike Chen",
        avatarUrl: "https://randomuser.me/api/portraits/women/2.jpg",
        status: "waiting_for_approve",
        actionAt: null
      }
    ]
  },
  /**
   * Pending request - half day, awaiting response
   */
  {
    id: "time-off-011",
    start: "2025-11-28T13:30:00Z",
    end: "2025-11-28T17:30:00Z",
    reason: "Afternoon off for personal appointment.",
    status: "waiting_for_approve",
    recipients: [
      {
        user: "sarah.johnson@company.com",
        name: "Sarah Johnson",
        avatarUrl: "https://randomuser.me/api/portraits/men/1.jpg",
        status: "waiting_for_approve",
        actionAt: null
      }
    ]
  },
  /**
   * Mixed approval status - pending final approver
   * Note: Status is waiting_for_approve if at least one recipient hasn't responded
   */
  {
    id: "time-off-012",
    start: "2025-11-22T08:00:00Z",
    end: "2025-11-22T17:30:00Z",
    reason: "Team building event preparation - off-site activity.",
    status: "waiting_for_approve",
    recipients: [
      {
        user: "sarah.johnson@company.com",
        name: "Sarah Johnson",
        avatarUrl: "https://randomuser.me/api/portraits/men/1.jpg",
        status: "approved",
        actionAt: "2025-11-20T10:00:00Z"
      },
      {
        user: "mike.chen@company.com",
        name: "Mike Chen",
        avatarUrl: "https://randomuser.me/api/portraits/women/2.jpg",
        status: "waiting_for_approve",
        actionAt: null
      },
      {
        user: "emily.davis@company.com",
        name: "Emily Davis",
        avatarUrl: "https://randomuser.me/api/portraits/men/2.jpg",
        status: "waiting_for_approve",
        actionAt: null
      }
    ]
  },
  /**
   * Emergency request - just submitted
   */
  {
    id: "time-off-013",
    start: "2025-11-21T08:00:00Z",
    end: "2025-11-21T17:30:00Z",
    reason: "Family emergency - unexpected urgent situation.",
    status: "waiting_for_approve",
    recipients: [
      {
        user: "sarah.johnson@company.com",
        name: "Sarah Johnson",
        avatarUrl: "https://randomuser.me/api/portraits/men/1.jpg",
        status: "waiting_for_approve",
        actionAt: null
      }
    ]
  },
  // ==================== EDGE CASES ====================
  /**
   * Single recipient - quickly approved
   */
  {
    id: "time-off-014",
    start: "2025-09-18T08:00:00Z",
    end: "2025-09-18T17:30:00Z",
    reason: "Single day off - minimal approval chain.",
    status: "approved",
    recipients: [
      {
        user: "alex.rodriguez@company.com",
        name: "Alex Rodriguez",
        avatarUrl: "https://randomuser.me/api/portraits/women/3.jpg",
        status: "approved",
        actionAt: "2025-09-17T16:20:00Z"
      }
    ]
  },
  /**
   * Many recipients - all approved
   */
  {
    id: "time-off-015",
    start: "2025-08-25T08:00:00Z",
    end: "2025-08-29T17:30:00Z",
    reason: "Annual summer vacation - project team coverage arranged.",
    status: "approved",
    recipients: [
      {
        user: "sarah.johnson@company.com",
        name: "Sarah Johnson",
        avatarUrl: "https://randomuser.me/api/portraits/men/1.jpg",
        status: "approved",
        actionAt: "2025-08-01T09:00:00Z"
      },
      {
        user: "mike.chen@company.com",
        name: "Mike Chen",
        avatarUrl: "https://randomuser.me/api/portraits/women/2.jpg",
        status: "approved",
        actionAt: "2025-08-01T09:30:00Z"
      },
      {
        user: "emily.davis@company.com",
        name: "Emily Davis",
        avatarUrl: "https://randomuser.me/api/portraits/men/2.jpg",
        status: "approved",
        actionAt: "2025-08-01T10:00:00Z"
      },
      {
        user: "alex.rodriguez@company.com",
        name: "Alex Rodriguez",
        avatarUrl: "https://randomuser.me/api/portraits/women/3.jpg",
        status: "approved",
        actionAt: "2025-08-01T10:30:00Z"
      }
    ]
  },
  /**
   * Very short request - 2 hours
   */
  {
    id: "time-off-016",
    start: "2025-10-14T10:00:00Z",
    end: "2025-10-14T12:00:00Z",
    reason: "Quick break for lunch meeting with friend.",
    status: "approved",
    recipients: [
      {
        user: "sarah.johnson@company.com",
        name: "Sarah Johnson",
        avatarUrl: "https://randomuser.me/api/portraits/men/1.jpg",
        status: "approved",
        actionAt: "2025-10-13T15:45:00Z"
      }
    ]
  },
  /**
   * Extended vacation - 2 weeks
   */
  {
    id: "time-off-017",
    start: "2025-07-01T08:00:00Z",
    end: "2025-07-14T17:30:00Z",
    reason: "Summer vacation - international trip planned. Will be offline for 2 weeks.",
    status: "approved",
    recipients: [
      {
        user: "sarah.johnson@company.com",
        name: "Sarah Johnson",
        avatarUrl: "https://randomuser.me/api/portraits/men/1.jpg",
        status: "approved",
        actionAt: "2025-06-15T08:00:00Z"
      },
      {
        user: "mike.chen@company.com",
        name: "Mike Chen",
        avatarUrl: "https://randomuser.me/api/portraits/women/2.jpg",
        status: "approved",
        actionAt: "2025-06-15T09:00:00Z"
      }
    ]
  }
];

// src/messages.ts
var MOCK_MESSSAGES = {
  SOMETHING_WENT_WRONG: "Something went wrong",
  NETWORK_ERROR: "Network error",
  UNAUTHORIZED: "Unauthorized",
  FETCH_FAILED: "Fetch failed",
  WARN_TARGET: "Abort error",
  WARN_MESSAGE_SUPPRESSED: "Abort error suppressed",
  ERROR_MESSAGE_UNRELATED: "Server timeout occurred",
  LOCALSTORAGE_ERROR: "LocalStorage error"
};
export {
  EMAIL,
  MOCK_ADDRESS_SUGGESTIONS,
  MOCK_JOB_TITLE,
  MOCK_MAPBOX_FEATURES,
  MOCK_MESSSAGES,
  MOCK_RESUMES,
  MOCK_USERS,
  PASSWORD,
  SAMPLE_TEXTS,
  SEMANTIC_ELEMENTS,
  activeUser,
  certifications,
  degrees,
  fieldsOfStudy,
  imageMock,
  inactiveUser,
  jobTitles,
  mockActionItems,
  mockClerkUser,
  mockMembers,
  mockMultipleDateStatusList,
  mockOptions,
  mockProjectActivities,
  mockResume,
  mockSampleDateStatusList,
  mockTemplateData,
  mockUsers,
  schools,
  socialLinks,
  techSkills,
  technicalSkills,
  timeOffRequestMocks,
  userWithoutUsername
};
